/**
 * SEO 配置 - video-to-video
 * 从 video-tools.ts 拆分，/video-to-video 页面独立 SEO 多语言文案
 */

export default {
    en: {
        videoToVideo: {
            title: 'Free Video to Video AI: Style Transfer | WeryAI',
            description: 'Free AI video style transfer -- turn footage into anime, 3D art, or cyberpunk in seconds. Smooth motion, no flickering. Online Vid2Vid by WeryAI.',
            keywords: 'video to video AI, AI video style transfer, vid2vid, turn video into anime AI, convert video to anime, AI video restyle, video filter AI, free video style transfer online, WeryAI',
            og_title: 'Free Video to Video AI: Style Transfer | WeryAI',
            og_description: 'Free AI video style transfer -- turn footage into anime, 3D art, or cyberpunk in seconds. Smooth motion, no flickering. Online Vid2Vid by WeryAI.',
            twitter_title: 'Free Video to Video AI: Style Transfer | WeryAI',
            twitter_description: 'Free AI video style transfer -- turn footage into anime, 3D art, or cyberpunk in seconds. Smooth motion, no flickering. Online Vid2Vid by WeryAI.',
            page: {
                title1: 'Free AI Video to Video Generator (Vid2Vid)',
                title2: `Upload a video, type a style, and watch the magic happen. WeryAI's Video to Video technology analyzes the motion in your source footage and applies a completely new artistic style based on your text prompt. Perfect for creating anime edits, claymation effects, or surreal visual art.`,
                feature_title1: 'Consistent Motion',
                feature_desc1: 'Unlike standard generation, our Vid2Vid engine locks onto the movement of your source video, ensuring smooth transitions without flickering.',
                feature_title2: 'Real to Anime',
                feature_desc2: 'The #1 tool for content creators. Turn yourself into an anime character or a 3D Pixar-style avatar instantly.',
                feature_title3: 'Prompt Control',
                feature_desc3: 'You have full creative control. Just type "Cyberpunk city style" or "Oil painting style" to define the exact look of the output.',
                faq: [
                    {
                        question: 'What is AI Video to Video (Vid2Vid)?',
                        answer: 'Video to Video is a generative AI process that takes an existing video clip as input and "repaints" it in a new style described by your text prompt, while preserving the original motion and structure.',
                    },
                    {
                        question: 'Can I turn my video into an anime style?',
                        answer: 'Yes! This is the most popular use case. Simply upload your video and enter prompts like "Japanese anime style, Studio Ghibli look" to transform your footage.',
                    },
                    {
                        question: 'How long can the source video be?',
                        answer: 'Currently, we support short clips (e.g., up to 5-10 seconds) to ensure the highest quality style transfer. For longer videos, we recommend splitting them into segments.',
                    },
                    {
                        question: 'Is it different from a video editor?',
                        answer: 'Yes. A traditional video editor cuts and trims clips. WeryAI Video to Video generates new pixels, completely changing the texture and artistic style of your footage.',
                    },
                    {
                        question: 'Can I use Video to Video for free?',
                        answer: 'New users get free credits upon signing up — no credit card required. Plus, you can earn more free credits through daily check-ins, completing tasks, and inviting friends, so you can keep using Video to Video style transfer without ever paying.',
                    },
                    {
                        question: 'What other ways can I create AI videos on WeryAI?',
                        answer: 'WeryAI also offers <a href="/text-to-video">Text to Video</a> to generate videos from written prompts, and <a href="/image-to-video">Image to Video</a> to animate your photos into motion. All tools share the same free daily credits.',
                    },
                ],
            },
            faq: [
                {
                    question: 'What is AI Video to Video (Vid2Vid)?',
                    answer: 'Video to Video is a generative AI process that takes an existing video clip as input and "repaints" it in a new style described by your text prompt, while preserving the original motion and structure.',
                },
                {
                    question: 'Can I turn my video into an anime style?',
                    answer: 'Yes! This is the most popular use case. Simply upload your video and enter prompts like "Japanese anime style, Studio Ghibli look" to transform your footage.',
                },
                {
                    question: 'How long can the source video be?',
                    answer: 'Currently, we support short clips (e.g., up to 5-10 seconds) to ensure the highest quality style transfer. For longer videos, we recommend splitting them into segments.',
                },
                {
                    question: 'Is it different from a video editor?',
                    answer: 'Yes. A traditional video editor cuts and trims clips. WeryAI Video to Video generates new pixels, completely changing the texture and artistic style of your footage.',
                },
                {
                    question: 'Can I use Video to Video for free?',
                    answer: 'New users get free credits upon signing up — no credit card required. Plus, you can earn more free credits through daily check-ins, completing tasks, and inviting friends, so you can keep using Video to Video style transfer without ever paying.',
                },
                {
                    question: 'What other ways can I create AI videos on WeryAI?',
                    answer: 'WeryAI also offers Text to Video to generate videos from written prompts, and Image to Video to animate your photos into motion. All tools share the same free daily credits.',
                },
            ],
        },
    },
    zh: {
        videoToVideo: {
            title: '免费 AI 视频转视频：风格迁移 | WeryAI',
            description: '免费 AI 视频风格迁移——秒变 anime、3D 艺术或 cyberpunk，动作流畅无闪烁。WeryAI 在线 Vid2Vid。',
            keywords: '视频转视频 AI, AI 视频风格迁移, vid2vid, 视频变 anime, 视频转动漫, AI 视频重风格, 视频滤镜 AI, 免费在线视频风格迁移, WeryAI',
            og_title: '免费 AI 视频转视频：风格迁移 | WeryAI',
            og_description: '免费 AI 视频风格迁移——秒变 anime、3D 艺术或 cyberpunk，动作流畅无闪烁。WeryAI 在线 Vid2Vid。',
            twitter_title: '免费 AI 视频转视频：风格迁移 | WeryAI',
            twitter_description: '免费 AI 视频风格迁移——秒变 anime、3D 艺术或 cyberpunk，动作流畅无闪烁。WeryAI 在线 Vid2Vid。',
            page: {
                title1: '免费 AI 视频转视频生成器（Vid2Vid）',
                title2: '上传一个视频，输入想要的风格，看魔法发生。WeryAI 的视频转视频技术会分析源视频的动作，并基于你的文本提示为其应用全新的艺术风格。非常适合制作动漫剪辑、黏土动画效果或超现实视觉艺术。',
                feature_title1: '动作一致性',
                feature_desc1: '不同于普通生成，我们的 Vid2Vid 引擎会锁定源视频的运动轨迹，确保转场更顺滑、减少闪烁。',
                feature_title2: '真人转动漫',
                feature_desc2: '内容创作者的热门选择：把自己一键变成动漫角色或 3D 皮克斯风格的形象。',
                feature_title3: '提示词可控',
                feature_desc3: '你拥有完整的创作控制权。只要输入“赛博朋克城市风格”或“油画风格”，即可定义输出的具体观感。',
                faq: [
                    {
                        question: '什么是 AI 视频转视频（Vid2Vid）？',
                        answer: '视频转视频是一种生成式 AI 流程：以现有视频片段为输入，根据你的文本提示“重绘”成新的风格，同时尽量保留原始动作与结构。',
                    },
                    {
                        question: '我可以把视频变成动漫风格吗？',
                        answer: '可以！这是最常见的用法。上传视频后输入类似“日系动漫风格、吉卜力画风”等提示词即可转换。',
                    },
                    {
                        question: '源视频最长支持多长？',
                        answer: '目前我们更适合处理短片段（例如 5–10 秒）以确保最佳风格迁移质量。更长视频建议分段处理。',
                    },
                    {
                        question: '它和传统视频剪辑软件有什么区别？',
                        answer: '有区别。传统剪辑是裁剪与拼接素材；WeryAI 的视频转视频会生成新的像素，彻底改变素材纹理与艺术风格。',
                    },
                    {
                        question: '视频转视频功能可以免费使用吗？',
                        answer: '新用户注册即可获得免费积分，无需绑定信用卡。此外，你还可以通过每日签到、完成任务和邀请好友持续获取免费积分，让你无需付费即可持续体验视频转视频功能。',
                    },
                    {
                        question: '在 WeryAI 上还有哪些方式可以创建 AI 视频？',
                        answer: 'WeryAI 还提供 <a href="/text-to-video">Text to Video</a>（根据文字提示生成视频）和 <a href="/image-to-video">Image to Video</a>（将照片动画化）。所有工具共享相同的每日免费积分。',
                    },
                ],
            },
            faq: [
                {
                    question: '什么是 AI 视频转视频（Vid2Vid）？',
                    answer: '视频转视频是一种生成式 AI 流程：以现有视频为输入，根据你的文本提示重绘成新风格，同时保留原始动作与结构。',
                },
                {
                    question: '我可以把视频变成动漫风格吗？',
                    answer: '可以。上传视频并输入“日系动漫风格、吉卜力画风”等提示词即可转换。',
                },
                {
                    question: '源视频最长支持多长？',
                    answer: '更适合短片段（例如 5–10 秒）以保证质量；更长视频建议分段处理。',
                },
                {
                    question: '它和传统视频剪辑软件有什么区别？',
                    answer: '传统剪辑是裁剪拼接；视频转视频会生成新像素，改变纹理与艺术风格。',
                },
                {
                    question: '视频转视频功能可以免费使用吗？',
                    answer: '注册即可获得免费积分，无需绑定信用卡。通过每日签到、完成任务和邀请好友可持续获取免费积分，畅享视频转视频功能。',
                },
                {
                    question: '在 WeryAI 上还有哪些方式可以创建 AI 视频？',
                    answer: 'WeryAI 还提供 Text to Video（根据文字提示生成视频）和 Image to Video（将照片动画化）。所有工具共享相同的每日免费积分。',
                },
            ],
        },
    },
    ja: {
        videoToVideo: {
            title: '無料 AI 動画→動画：スタイル変換 | WeryAI',
            description: '無料 AI 動画スタイル変換──映像を anime・3D アート・cyberpunk に数秒で変換。滑らかな動き、ちらつきなし。WeryAI のオンライン Vid2Vid。',
            keywords: '動画から動画 AI, AI 動画スタイル変換, vid2vid, 動画を anime に変換, 動画をアニメに, AI 動画リスタイル, 動画フィルター AI, 無料オンライン動画スタイル変換, WeryAI',
            og_title: '無料 AI 動画→動画：スタイル変換 | WeryAI',
            og_description: '無料 AI 動画スタイル変換──映像を anime・3D アート・cyberpunk に数秒で変換。滑らかな動き、ちらつきなし。WeryAI のオンライン Vid2Vid。',
            twitter_title: '無料 AI 動画→動画：スタイル変換 | WeryAI',
            twitter_description: '無料 AI 動画スタイル変換──映像を anime・3D アート・cyberpunk に数秒で変換。滑らかな動き、ちらつきなし。WeryAI のオンライン Vid2Vid。',
            page: {
                title1: '無料 AI 動画→動画ジェネレーター（Vid2Vid）',
                title2: '動画をアップロードして、スタイルを入力するだけ。WeryAI の動画→動画技術が元動画の動きを解析し、あなたのテキストプロンプトに基づいて全く新しいアートスタイルを適用します。アニメ編集、クレイアニメ風、超現実的な映像表現に最適です。',
                feature_title1: '動きの一貫性',
                feature_desc1: '通常の生成と違い、Vid2Vid エンジンが元動画の動きを捉え、ちらつきを抑えて滑らかな変換を実現します。',
                feature_title2: '実写→アニメ',
                feature_desc2: 'クリエイターに人気。自分の映像をアニメキャラや 3D ピクサー風アバターに一瞬で変換できます。',
                feature_title3: 'プロンプトでコントロール',
                feature_desc3: '「サイバーパンク都市風」や「油絵風」のように入力するだけで、出力の見た目を細かく指定できます。',
                faq: [
                    {
                        question: 'AI 動画→動画（Vid2Vid）とは？',
                        answer: '既存の動画を入力として、テキストプロンプトで指定した新しいスタイルに「塗り替える」生成 AI 技術です。元の動きと構造をできるだけ維持します。',
                    },
                    {
                        question: '動画をアニメ風にできますか？',
                        answer: 'はい。最も人気の使い方です。動画をアップロードし「日本アニメ風、ジブリ風」などのプロンプトで変換できます。',
                    },
                    {
                        question: '元動画の長さはどれくらいまで対応？',
                        answer: '高品質を保つため、現在は短いクリップ（例：5〜10 秒）を推奨しています。長い動画は分割して処理してください。',
                    },
                    {
                        question: '動画編集ソフトと何が違う？',
                        answer: '従来の編集はカットやトリミング中心ですが、WeryAI の動画→動画は新しいピクセルを生成し、質感やアートスタイル自体を変えます。',
                    },
                    {
                        question: 'Video to Video を無料で使えますか？',
                        answer: '新規登録で無料クレジットがもらえます。クレジットカードの登録は不要です。さらに、毎日のチェックイン、タスクの完了、友達の招待で追加の無料クレジットを獲得でき、費用をかけずに動画スタイル変換を継続的にご利用いただけます。',
                    },
                    {
                        question: 'WeryAI で AI 動画を作る他の方法は？',
                        answer: 'WeryAI では <a href="/text-to-video">Text to Video</a>（テキストから動画を生成）や <a href="/image-to-video">Image to Video</a>（写真をアニメーション化）も利用できます。すべてのツールで毎日の無料クレジットを共有しています。',
                    },
                ],
            },
            faq: [
                {
                    question: 'AI 動画→動画（Vid2Vid）とは？',
                    answer: '既存動画を入力に、テキストで指定した新スタイルへリスタイルしつつ動きと構造を保つ生成 AI です。',
                },
                {
                    question: '動画をアニメ風にできますか？',
                    answer: 'はい。「日本アニメ風、ジブリ風」などのプロンプトで変換できます。',
                },
                {
                    question: '元動画の長さはどれくらいまで対応？',
                    answer: '現在は短いクリップ（例：5〜10 秒）推奨。長い動画は分割してください。',
                },
                {
                    question: '動画編集ソフトと何が違う？',
                    answer: '編集はカット中心、Vid2Vid は新ピクセル生成で質感・スタイルを変えます。',
                },
                {
                    question: 'Video to Video を無料で使えますか？',
                    answer: '新規登録で無料クレジットを獲得、クレジットカード不要。毎日のチェックイン・タスク完了・友達招待でさらに無料クレジットを獲得し、動画スタイル変換を無料で使い続けられます。',
                },
                {
                    question: 'WeryAI で AI 動画を作る他の方法は？',
                    answer: 'WeryAI では Text to Video（テキストから動画生成）や Image to Video（写真のアニメーション化）も利用可能です。すべてのツールで毎日の無料クレジットを共有しています。',
                },
            ],
        },
    },
    ko: {
        videoToVideo: {
            title: '무료 AI 비디오→비디오: 스타일 변환 | WeryAI',
            description: '무료 AI 비디오 스타일 변환 -- 영상을 anime, 3D 아트, cyberpunk로 몇 초 만에 변환. 부드러운 모션, 깜빡임 없음. WeryAI 온라인 Vid2Vid.',
            keywords: '비디오 투 비디오 AI, AI 비디오 스타일 변환, vid2vid, 비디오를 anime으로, 비디오 애니 변환, AI 비디오 리스타일, 비디오 필터 AI, 무료 온라인 비디오 스타일 변환, WeryAI',
            og_title: '무료 AI 비디오→비디오: 스타일 변환 | WeryAI',
            og_description: '무료 AI 비디오 스타일 변환 -- 영상을 anime, 3D 아트, cyberpunk로 몇 초 만에 변환. 부드러운 모션, 깜빡임 없음. WeryAI 온라인 Vid2Vid.',
            twitter_title: '무료 AI 비디오→비디오: 스타일 변환 | WeryAI',
            twitter_description: '무료 AI 비디오 스타일 변환 -- 영상을 anime, 3D 아트, cyberpunk로 몇 초 만에 변환. 부드러운 모션, 깜빡임 없음. WeryAI 온라인 Vid2Vid.',
            page: {
                title1: '무료 AI 비디오→비디오 생성기 (Vid2Vid)',
                title2: '비디오를 업로드하고 스타일을 입력하면 끝. WeryAI의 비디오→비디오 기술이 원본 영상의 움직임을 분석하고, 텍스트 프롬프트에 따라 완전히 새로운 아트 스타일을 적용합니다. 애니 편집, 클레이메이션 효과, 초현실 비주얼 제작에 적합합니다.',
                feature_title1: '일관된 모션',
                feature_desc1: '일반 생성과 달리 Vid2Vid 엔진이 원본 움직임을 고정해 깜빡임을 줄이고 부드러운 전환을 제공합니다.',
                feature_title2: '실사 → 애니',
                feature_desc2: '크리에이터에게 인기 #1. 나를 애니 캐릭터나 3D 픽사풍 아바타로 즉시 변환하세요.',
                feature_title3: '프롬프트 컨트롤',
                feature_desc3: '"사이버펑크 도시 스타일" 또는 "유화 스타일"처럼 입력해 결과의 느낌을 정확히 지정할 수 있습니다.',
                faq: [
                    {
                        question: 'AI 비디오→비디오(Vid2Vid)란 무엇인가요?',
                        answer: '기존 비디오 클립을 입력으로 받아, 텍스트 프롬프트로 지정한 새로운 스타일로 “다시 그리되”, 원본의 움직임과 구조를 최대한 유지하는 생성형 AI 과정입니다.',
                    },
                    {
                        question: '비디오를 애니메이션 스타일로 바꿀 수 있나요?',
                        answer: '네! 가장 인기 있는 사용 사례입니다. 비디오를 업로드한 뒤 “일본 애니 스타일, 지브리 느낌” 같은 프롬프트를 입력하면 변환됩니다.',
                    },
                    {
                        question: '원본 비디오 길이는 얼마나 지원하나요?',
                        answer: '현재는 최고 품질을 위해 짧은 클립(예: 5~10초)을 지원/권장합니다. 더 긴 영상은 구간을 나눠 처리하는 것을 추천합니다.',
                    },
                    {
                        question: '일반 비디오 편집기와 무엇이 다른가요?',
                        answer: '전통적인 편집기는 자르고 붙이는 작업이 중심입니다. WeryAI 비디오→비디오는 새로운 픽셀을 생성해 질감과 아트 스타일 자체를 바꿉니다.',
                    },
                    {
                        question: 'Video to Video를 무료로 사용할 수 있나요?',
                        answer: '신규 가입 시 무료 크레딧이 제공되며, 신용카드 등록이 필요 없습니다. 또한 매일 출석 체크, 미션 완료, 친구 초대를 통해 추가 무료 크레딧을 획득할 수 있어 비용 없이 비디오 스타일 변환 기능을 계속 이용할 수 있습니다.',
                    },
                    {
                        question: 'WeryAI에서 AI 비디오를 만드는 다른 방법은?',
                        answer: 'WeryAI는 <a href="/text-to-video">Text to Video</a>(텍스트 프롬프트로 비디오 생성)와 <a href="/image-to-video">Image to Video</a>(사진을 애니메이션으로 변환)도 제공합니다. 모든 도구는 동일한 무료 일일 크레딧을 공유합니다.',
                    },
                ],
            },
            faq: [
                {
                    question: 'AI 비디오→비디오(Vid2Vid)란 무엇인가요?',
                    answer: '기존 비디오를 입력으로, 프롬프트로 지정한 새 스타일로 재도색하면서 원본 모션/구조를 유지하는 생성형 AI입니다.',
                },
                {
                    question: '비디오를 애니메이션 스타일로 바꿀 수 있나요?',
                    answer: '네. “일본 애니 스타일, 지브리 느낌” 같은 프롬프트로 변환할 수 있습니다.',
                },
                {
                    question: '원본 비디오 길이는 얼마나 지원하나요?',
                    answer: '현재는 5~10초 같은 짧은 클립을 권장합니다. 긴 영상은 분할해 주세요.',
                },
                {
                    question: '일반 비디오 편집기와 무엇이 다른가요?',
                    answer: '편집기는 컷/트림, Vid2Vid는 새 픽셀 생성으로 질감과 스타일을 변경합니다.',
                },
                {
                    question: 'Video to Video를 무료로 사용할 수 있나요?',
                    answer: '신규 가입 시 무료 크레딧 제공, 신용카드 불필요. 매일 출석 체크, 미션 완료, 친구 초대로 추가 크레딧을 획득하여 비디오 스타일 변환을 무료로 계속 이용하세요.',
                },
                {
                    question: 'WeryAI에서 AI 비디오를 만드는 다른 방법은?',
                    answer: 'WeryAI는 Text to Video(텍스트 프롬프트로 비디오 생성)와 Image to Video(사진을 애니메이션으로 변환)도 제공합니다. 모든 도구는 동일한 무료 일일 크레딧을 공유합니다.',
                },
            ],
        },
    },
    es: {
        videoToVideo: {
            title: 'IA Video a Video Gratis: Transferencia de Estilo | WeryAI',
            description: 'Transferencia de estilo de video con IA gratis — convierte metraje en anime, arte 3D o cyberpunk en segundos. Movimiento fluido, sin parpadeo. Vid2Vid WeryAI.',
            keywords: 'video a video IA, transferencia de estilo de video IA, vid2vid, convertir video en anime IA, convertir video a anime, IA restyle de video, filtro de video IA, transferencia de estilo de video gratis online, WeryAI',
            og_title: 'IA Video a Video Gratis: Transferencia de Estilo | WeryAI',
            og_description: 'Transferencia de estilo de video con IA gratis — convierte metraje en anime, arte 3D o cyberpunk en segundos. Movimiento fluido, sin parpadeo. Vid2Vid WeryAI.',
            twitter_title: 'IA Video a Video Gratis: Transferencia de Estilo | WeryAI',
            twitter_description: 'Transferencia de estilo de video con IA gratis — convierte metraje en anime, arte 3D o cyberpunk en segundos. Movimiento fluido, sin parpadeo. Vid2Vid WeryAI.',
            page: {
                title1: 'Generador Gratis de Video a Video con IA (Vid2Vid)',
                title2: 'Sube un video, escribe un estilo y mira la magia. La tecnología Video a Video de WeryAI analiza el movimiento del metraje original y aplica un estilo artístico completamente nuevo según tu prompt. Ideal para edits anime, efectos de stop‑motion tipo plastilina o arte visual surrealista.',
                feature_title1: 'Movimiento Consistente',
                feature_desc1: 'A diferencia de una generación estándar, nuestro motor Vid2Vid se “ancla” al movimiento del video fuente para lograr transiciones suaves sin parpadeos.',
                feature_title2: 'De Real a Anime',
                feature_desc2: 'La herramienta #1 para creadores. Conviértete al instante en un personaje anime o en un avatar 3D estilo Pixar.',
                feature_title3: 'Control con Prompts',
                feature_desc3: 'Tienes control creativo total. Escribe “estilo ciudad cyberpunk” o “estilo pintura al óleo” para definir exactamente el look del resultado.',
                faq: [
                    {
                        question: '¿Qué es la IA de Video a Video (Vid2Vid)?',
                        answer: 'Video a Video es un proceso de IA generativa que toma un clip existente como entrada y lo “repinta” en un nuevo estilo descrito por tu prompt, manteniendo el movimiento y la estructura originales.',
                    },
                    {
                        question: '¿Puedo convertir mi video a estilo anime?',
                        answer: 'Sí. Es el caso de uso más popular. Sube tu video e ingresa prompts como “estilo anime japonés, look Studio Ghibli” para transformarlo.',
                    },
                    {
                        question: '¿Qué tan largo puede ser el video fuente?',
                        answer: 'Actualmente soportamos clips cortos (por ejemplo, 5–10 segundos) para asegurar la mejor calidad. Para videos largos, recomendamos dividirlos en segmentos.',
                    },
                    {
                        question: '¿En qué se diferencia de un editor de video?',
                        answer: 'Un editor tradicional recorta y corta clips. Video a Video de WeryAI genera nuevos píxeles, cambiando por completo la textura y el estilo artístico del metraje.',
                    },
                    {
                        question: '¿Puedo usar Video to Video gratis?',
                        answer: 'Los nuevos usuarios reciben créditos gratis al registrarse, sin necesidad de tarjeta de crédito. Además, puedes ganar más créditos gratis con el check-in diario, completando tareas e invitando amigos, para seguir usando la transferencia de estilo de video sin pagar.',
                    },
                    {
                        question: '¿De qué otras formas puedo crear videos con IA en WeryAI?',
                        answer: 'WeryAI también ofrece <a href="/text-to-video">Text to Video</a> para generar videos a partir de indicaciones escritas, e <a href="/image-to-video">Image to Video</a> para animar tus fotos. Todas las herramientas comparten los mismos créditos diarios gratuitos.',
                    },
                ],
            },
            faq: [
                {
                    question: '¿Qué es la IA de Video a Video (Vid2Vid)?',
                    answer: 'Toma un video existente y lo “repinta” en un nuevo estilo mediante prompts, preservando movimiento y estructura.',
                },
                {
                    question: '¿Puedo convertir mi video a estilo anime?',
                    answer: 'Sí. Sube tu video y usa prompts como “estilo anime japonés, Studio Ghibli”.',
                },
                {
                    question: '¿Qué tan largo puede ser el video fuente?',
                    answer: 'Recomendamos clips cortos (5–10 s) para máxima calidad; para largos, divide en segmentos.',
                },
                {
                    question: '¿En qué se diferencia de un editor de video?',
                    answer: 'Un editor recorta; Vid2Vid genera nuevos píxeles y cambia textura/estilo del metraje.',
                },
                {
                    question: '¿Puedo usar Video to Video gratis?',
                    answer: 'Al registrarte obtienes créditos gratis sin tarjeta de crédito. Gana más con check-in diario, tareas e invitando amigos para usar la transferencia de estilo de video gratis de forma continua.',
                },
                {
                    question: '¿De qué otras formas puedo crear videos con IA en WeryAI?',
                    answer: 'WeryAI también ofrece Text to Video para generar videos a partir de indicaciones escritas, e Image to Video para animar tus fotos. Todas las herramientas comparten los mismos créditos diarios gratuitos.',
                },
            ],
        },
    },
    fr: {
        videoToVideo: {
            title: 'IA Vidéo vers Vidéo Gratuite : Transfert de Style | WeryAI',
            description: 'Transfert de style vidéo par IA gratuit — transformez vos séquences en anime, art 3D ou cyberpunk en secondes. Mouvement fluide, sans scintillement. Vid2Vid.',
            keywords: 'vidéo vers vidéo IA, transfert de style vidéo IA, vid2vid, transformer vidéo en anime IA, convertir vidéo en anime, IA restyle vidéo, filtre vidéo IA, transfert de style vidéo gratuit en ligne, WeryAI',
            og_title: 'IA Vidéo vers Vidéo Gratuite : Transfert de Style | WeryAI',
            og_description: 'Transfert de style vidéo par IA gratuit — transformez vos séquences en anime, art 3D ou cyberpunk en secondes. Mouvement fluide, sans scintillement. Vid2Vid.',
            twitter_title: 'IA Vidéo vers Vidéo Gratuite : Transfert de Style | WeryAI',
            twitter_description: 'Transfert de style vidéo par IA gratuit — transformez vos séquences en anime, art 3D ou cyberpunk en secondes. Mouvement fluide, sans scintillement. Vid2Vid.',
            page: {
                title1: 'Générateur IA Vidéo→Vidéo Gratuit (Vid2Vid)',
                title2: 'Importez une vidéo, tapez un style et regardez la magie opérer. La technologie Vidéo→Vidéo de WeryAI analyse le mouvement de votre vidéo source et applique un tout nouveau style artistique selon votre prompt. Parfait pour des edits anime, des effets type claymation, ou des visuels surréalistes.',
                feature_title1: 'Mouvement Cohérent',
                feature_desc1: 'Contrairement à une génération standard, notre moteur Vid2Vid s’accroche au mouvement de la vidéo source pour des transitions fluides sans scintillement.',
                feature_title2: 'Du Réel à l’Anime',
                feature_desc2: 'L’outil n°1 pour les créateurs. Transformez-vous instantanément en personnage anime ou en avatar 3D style Pixar.',
                feature_title3: 'Contrôle par Prompt',
                feature_desc3: 'Vous gardez le contrôle créatif. Tapez simplement « style ville cyberpunk » ou « style peinture à l’huile » pour définir précisément le rendu.',
                faq: [
                    {
                        question: 'Qu’est-ce que l’IA Vidéo→Vidéo (Vid2Vid) ?',
                        answer: 'La Vidéo→Vidéo est un procédé d’IA générative qui prend une vidéo existante en entrée et la « repeint » dans un nouveau style décrit par votre prompt, tout en préservant le mouvement et la structure d’origine.',
                    },
                    {
                        question: 'Puis-je transformer ma vidéo en style anime ?',
                        answer: 'Oui ! C’est le cas d’usage le plus populaire. Importez votre vidéo et utilisez des prompts comme « anime japonais, style Studio Ghibli » pour la transformer.',
                    },
                    {
                        question: 'Quelle longueur pour la vidéo source ?',
                        answer: 'Pour garantir la meilleure qualité, nous supportons surtout des clips courts (par ex. 5–10 secondes). Pour des vidéos plus longues, nous recommandons de les découper en segments.',
                    },
                    {
                        question: 'En quoi est-ce différent d’un éditeur vidéo ?',
                        answer: 'Un éditeur traditionnel coupe et assemble. L’outil Vidéo→Vidéo de WeryAI génère de nouveaux pixels et change complètement la texture et le style artistique de vos images.',
                    },
                    {
                        question: 'Puis-je utiliser Video to Video gratuitement ?',
                        answer: "Les nouveaux utilisateurs reçoivent des crédits gratuits dès l'inscription, sans carte bancaire requise. De plus, vous pouvez gagner davantage de crédits gratuits grâce au check-in quotidien, à l'accomplissement de tâches et à l'invitation d'amis, pour continuer à utiliser le transfert de style vidéo sans jamais payer.",
                    },
                    {
                        question: 'Quels autres moyens de créer des vidéos IA sur WeryAI ?',
                        answer: 'WeryAI propose aussi <a href="/text-to-video">Text to Video</a> pour générer des vidéos à partir de texte, et <a href="/image-to-video">Image to Video</a> pour animer vos photos. Tous les outils partagent les mêmes crédits quotidiens gratuits.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Qu’est-ce que l’IA Vidéo→Vidéo (Vid2Vid) ?',
                    answer: 'Elle « repeint » une vidéo existante dans un nouveau style via un prompt, en conservant mouvement et structure.',
                },
                {
                    question: 'Puis-je transformer ma vidéo en style anime ?',
                    answer: 'Oui. Importez votre vidéo et essayez « anime japonais, style Studio Ghibli ».',
                },
                {
                    question: 'Quelle longueur pour la vidéo source ?',
                    answer: 'Nous recommandons des clips courts (5–10 s) ; pour plus long, découpez en segments.',
                },
                {
                    question: 'En quoi est-ce différent d’un éditeur vidéo ?',
                    answer: 'Un éditeur coupe ; Vid2Vid génère de nouveaux pixels et change le style/texture.',
                },
                {
                    question: 'Puis-je utiliser Video to Video gratuitement ?',
                    answer: "Crédits gratuits dès l'inscription, sans carte bancaire. Gagnez-en davantage via le check-in quotidien, les tâches et l'invitation d'amis pour profiter du transfert de style vidéo en continu.",
                },
                {
                    question: 'Quels autres moyens de créer des vidéos IA sur WeryAI ?',
                    answer: 'WeryAI propose aussi Text to Video pour générer des vidéos à partir de texte, et Image to Video pour animer vos photos. Tous les outils partagent les mêmes crédits quotidiens gratuits.',
                },
            ],
        },
    },
    de: {
        videoToVideo: {
            title: 'Kostenlose KI Video-zu-Video: Stiltransfer | WeryAI',
            description: 'Kostenloser KI-Video-Stiltransfer — Footage in Anime, 3D-Kunst oder Cyberpunk verwandeln, in Sekunden. Flüssige Bewegung, kein Flackern. Vid2Vid von WeryAI.',
            keywords: 'Video zu Video KI, KI Video Stiltransfer, vid2vid, Video in anime verwandeln KI, Video zu Anime konvertieren, KI Video Restyle, Videofilter KI, kostenloser Video-Stiltransfer online, WeryAI',
            og_title: 'Kostenlose KI Video-zu-Video: Stiltransfer | WeryAI',
            og_description: 'Kostenloser KI-Video-Stiltransfer — Footage in Anime, 3D-Kunst oder Cyberpunk verwandeln, in Sekunden. Flüssige Bewegung, kein Flackern. Vid2Vid von WeryAI.',
            twitter_title: 'Kostenlose KI Video-zu-Video: Stiltransfer | WeryAI',
            twitter_description: 'Kostenloser KI-Video-Stiltransfer — Footage in Anime, 3D-Kunst oder Cyberpunk verwandeln, in Sekunden. Flüssige Bewegung, kein Flackern. Vid2Vid von WeryAI.',
            page: {
                title1: 'Kostenloser KI Video-zu-Video Generator (Vid2Vid)',
                title2: 'Laden Sie ein Video hoch, geben Sie einen Stil ein – und sehen Sie die Magie. WeryAIs Video-zu-Video-Technologie analysiert die Bewegung Ihres Quellvideos und wendet anhand Ihres Text-Prompts einen komplett neuen Kunststil an. Perfekt für Anime-Edits, Claymation-Effekte oder surreale Visuals.',
                feature_title1: 'Konsistente Bewegung',
                feature_desc1: 'Anders als bei Standard-Generierung „rastet“ unsere Vid2Vid-Engine in die Bewegung des Quellvideos ein und sorgt für flüssige Übergänge ohne Flackern.',
                feature_title2: 'Real zu Anime',
                feature_desc2: 'Tool #1 für Creator: Verwandeln Sie sich sofort in eine Anime-Figur oder einen 3D-Pixar-Style-Avatar.',
                feature_title3: 'Prompt-Kontrolle',
                feature_desc3: 'Volle kreative Kontrolle: Tippen Sie einfach „Cyberpunk-City Style“ oder „Ölgemälde Style“, um den Look exakt zu definieren.',
                faq: [
                    {
                        question: 'Was ist KI Video-zu-Video (Vid2Vid)?',
                        answer: 'Video-zu-Video ist ein generativer KI-Prozess, der ein vorhandenes Video als Input nimmt und es in einem neuen, durch Ihren Prompt beschriebenen Stil „neu malt“, während Bewegung und Struktur erhalten bleiben.',
                    },
                    {
                        question: 'Kann ich mein Video in einen Anime-Stil verwandeln?',
                        answer: 'Ja! Das ist der beliebteste Anwendungsfall. Laden Sie Ihr Video hoch und nutzen Sie Prompts wie „Japanese anime style, Studio Ghibli look“.',
                    },
                    {
                        question: 'Wie lang darf das Quellvideo sein?',
                        answer: 'Aktuell empfehlen wir kurze Clips (z. B. 5–10 Sekunden) für die beste Qualität. Für längere Videos empfehlen wir, sie in Segmente zu teilen.',
                    },
                    {
                        question: 'Worin unterscheidet es sich von einem Videoeditor?',
                        answer: 'Ein klassischer Editor schneidet und trimmt Clips. WeryAI Video-zu-Video erzeugt neue Pixel und verändert Textur und Kunststil Ihres Materials vollständig.',
                    },
                    {
                        question: 'Kann ich Video to Video kostenlos nutzen?',
                        answer: 'Neue Nutzer erhalten bei der Registrierung Gratis-Credits — keine Kreditkarte erforderlich. Außerdem können Sie durch tägliches Einchecken, das Abschließen von Aufgaben und das Einladen von Freunden weitere Gratis-Credits verdienen, um den Video-Stiltransfer dauerhaft kostenlos zu nutzen.',
                    },
                    {
                        question: 'Welche anderen Möglichkeiten gibt es, KI-Videos auf WeryAI zu erstellen?',
                        answer: 'WeryAI bietet auch <a href="/text-to-video">Text to Video</a> zum Generieren von Videos aus Texteingaben und <a href="/image-to-video">Image to Video</a> zum Animieren Ihrer Fotos. Alle Tools teilen sich die gleichen täglichen Gratis-Credits.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Was ist KI Video-zu-Video (Vid2Vid)?',
                    answer: 'Es „malt“ ein bestehendes Video per Prompt in einen neuen Stil um und behält Bewegung und Struktur bei.',
                },
                {
                    question: 'Kann ich mein Video in einen Anime-Stil verwandeln?',
                    answer: 'Ja. Probieren Sie Prompts wie „Japanese anime style, Studio Ghibli look“.',
                },
                {
                    question: 'Wie lang darf das Quellvideo sein?',
                    answer: 'Für beste Qualität empfehlen wir kurze Clips (5–10 s). Lange Videos bitte segmentieren.',
                },
                {
                    question: 'Worin unterscheidet es sich von einem Videoeditor?',
                    answer: 'Editor = schneiden; Vid2Vid = neue Pixel generieren und Stil/Textur verändern.',
                },
                {
                    question: 'Kann ich Video to Video kostenlos nutzen?',
                    answer: 'Bei der Registrierung erhalten Sie Gratis-Credits, ohne Kreditkarte. Durch tägliches Einchecken, Aufgaben und Freunde einladen verdienen Sie weitere Gratis-Credits für dauerhaft kostenlosen Video-Stiltransfer.',
                },
                {
                    question: 'Welche anderen Möglichkeiten gibt es, KI-Videos auf WeryAI zu erstellen?',
                    answer: 'WeryAI bietet auch Text to Video zum Generieren von Videos aus Texteingaben und Image to Video zum Animieren Ihrer Fotos. Alle Tools teilen sich die gleichen täglichen Gratis-Credits.',
                },
            ],
        },
    },
    ru: {
        videoToVideo: {
            title: 'Бесплатный AI Video to Video: Стиль-трансфер | WeryAI',
            description: 'Бесплатный AI-трансфер стиля видео — превратите видео в anime, 3D-арт или cyberpunk за секунды. Плавное движение, без мерцания. Онлайн Vid2Vid от WeryAI.',
            keywords: 'видео в видео ИИ, AI трансфер стиля видео, vid2vid, превратить видео в anime, видео в аниме, рестайл видео AI, видеофильтр AI, бесплатный онлайн трансфер стиля видео, WeryAI',
            og_title: 'Бесплатный AI Video to Video: Стиль-трансфер | WeryAI',
            og_description: 'Бесплатный AI-трансфер стиля видео — превратите видео в anime, 3D-арт или cyberpunk за секунды. Плавное движение, без мерцания. Онлайн Vid2Vid от WeryAI.',
            twitter_title: 'Бесплатный AI Video to Video: Стиль-трансфер | WeryAI',
            twitter_description: 'Бесплатный AI-трансфер стиля видео — превратите видео в anime, 3D-арт или cyberpunk за секунды. Плавное движение, без мерцания. Онлайн Vid2Vid от WeryAI.',
            page: {
                title1: 'Бесплатный AI Video‑to‑Video генератор (Vid2Vid)',
                title2: 'Загрузите видео, укажите стиль — и наблюдайте магию. Технология Video‑to‑Video от WeryAI анализирует движение исходного ролика и применяет совершенно новый художественный стиль по вашему текстовому промпту. Отлично подходит для аниме‑эдитов, эффектов claymation и сюрреалистичных визуалов.',
                feature_title1: 'Стабильное движение',
                feature_desc1: 'В отличие от обычной генерации, наш Vid2Vid‑движок «цепляется» за движение исходника и делает переходы плавными без мерцания.',
                feature_title2: 'Из Реала в Аниме',
                feature_desc2: 'Топ‑инструмент для креаторов: превратите себя в аниме‑персонажа или 3D‑аватар в стиле Pixar за секунды.',
                feature_title3: 'Контроль промптом',
                feature_desc3: 'Полный творческий контроль: просто напишите «киберпанк‑город» или «масляная живопись», чтобы точно задать внешний вид результата.',
                faq: [
                    {
                        question: 'Что такое AI Video‑to‑Video (Vid2Vid)?',
                        answer: 'Video‑to‑Video — это генеративный процесс, который берёт готовый видеоклип как вход и «перерисовывает» его в новом стиле по вашему промпту, сохраняя исходное движение и структуру.',
                    },
                    {
                        question: 'Можно ли превратить видео в аниме‑стиль?',
                        answer: 'Да! Это самый популярный сценарий. Загрузите видео и используйте промпты вроде «японское аниме, стиль Studio Ghibli».',
                    },
                    {
                        question: 'Какой максимальной длины может быть исходный ролик?',
                        answer: 'Сейчас лучше всего поддерживаются короткие клипы (например, 5–10 секунд) для максимального качества. Длинные видео рекомендуем делить на части.',
                    },
                    {
                        question: 'Чем это отличается от видеоредактора?',
                        answer: 'Обычный редактор режет и склеивает клипы. WeryAI Video‑to‑Video генерирует новые пиксели и полностью меняет текстуру и художественный стиль вашего видео.',
                    },
                    {
                        question: 'Можно ли использовать Video to Video бесплатно?',
                        answer: 'Новые пользователи получают бесплатные кредиты при регистрации — банковская карта не нужна. Кроме того, вы можете зарабатывать дополнительные бесплатные кредиты через ежедневную отметку, выполнение заданий и приглашение друзей, чтобы пользоваться стилизацией видео бесплатно без ограничений.',
                    },
                    {
                        question: 'Какие ещё способы создания AI-видео есть на WeryAI?',
                        answer: 'WeryAI также предлагает <a href="/text-to-video">Text to Video</a> для генерации видео по тексту и <a href="/image-to-video">Image to Video</a> для анимации фотографий. Все инструменты используют одни и те же бесплатные ежедневные кредиты.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Что такое AI Video‑to‑Video (Vid2Vid)?',
                    answer: 'Это «перерисовка» существующего видео в новый стиль по промпту с сохранением движения и структуры.',
                },
                {
                    question: 'Можно ли превратить видео в аниме‑стиль?',
                    answer: 'Да. Попробуйте промпты вроде «японское аниме, Studio Ghibli».',
                },
                {
                    question: 'Какой максимальной длины может быть исходный ролик?',
                    answer: 'Рекомендуем 5–10 секунд для лучшего качества; длинные видео делите на сегменты.',
                },
                {
                    question: 'Чем это отличается от видеоредактора?',
                    answer: 'Редактор режет клипы, а Vid2Vid генерирует новые пиксели и меняет стиль/текстуру.',
                },
                {
                    question: 'Можно ли использовать Video to Video бесплатно?',
                    answer: 'При регистрации вы получаете бесплатные кредиты без привязки карты. Зарабатывайте ещё через ежедневную отметку, задания и приглашение друзей для бесплатной стилизации видео.',
                },
                {
                    question: 'Какие ещё способы создания AI-видео есть на WeryAI?',
                    answer: 'WeryAI также предлагает Text to Video для генерации видео по тексту и Image to Video для анимации фотографий. Все инструменты используют одни и те же бесплатные ежедневные кредиты.',
                },
            ],
        },
    },
    pt: {
        videoToVideo: {
            title: 'IA Vídeo para Vídeo Grátis: Transferência de Estilo | WeryAI',
            description: 'Transferência de estilo de vídeo com IA grátis — transforme filmagens em anime, arte 3D ou cyberpunk em segundos. Movimento suave, sem cintilação. Vid2Vid.',
            keywords: 'vídeo para vídeo IA, transferência de estilo de vídeo IA, vid2vid, transformar vídeo em anime IA, converter vídeo em anime, IA restyle de vídeo, filtro de vídeo IA, transferência de estilo de vídeo grátis online, WeryAI',
            og_title: 'IA Vídeo para Vídeo Grátis: Transferência de Estilo | WeryAI',
            og_description: 'Transferência de estilo de vídeo com IA grátis — transforme filmagens em anime, arte 3D ou cyberpunk em segundos. Movimento suave, sem cintilação. Vid2Vid.',
            twitter_title: 'IA Vídeo para Vídeo Grátis: Transferência de Estilo | WeryAI',
            twitter_description: 'Transferência de estilo de vídeo com IA grátis — transforme filmagens em anime, arte 3D ou cyberpunk em segundos. Movimento suave, sem cintilação. Vid2Vid.',
            page: {
                title1: 'Gerador Gratuito de Vídeo para Vídeo com IA (Vid2Vid)',
                title2: 'Envie um vídeo, digite um estilo e veja a mágica. A tecnologia Vídeo‑para‑Vídeo da WeryAI analisa o movimento do seu vídeo de origem e aplica um novo estilo artístico baseado no seu prompt. Perfeito para edits de anime, efeitos tipo claymation ou artes visuais surreais.',
                feature_title1: 'Movimento Consistente',
                feature_desc1: 'Diferente da geração padrão, nosso motor Vid2Vid “gruda” no movimento do vídeo fonte, garantindo transições suaves sem flicker.',
                feature_title2: 'Real para Anime',
                feature_desc2: 'A ferramenta #1 para criadores: transforme-se em um personagem de anime ou avatar 3D estilo Pixar em instantes.',
                feature_title3: 'Controle por Prompt',
                feature_desc3: 'Controle criativo total: basta digitar “cidade cyberpunk” ou “pintura a óleo” para definir exatamente o visual do resultado.',
                faq: [
                    {
                        question: 'O que é IA de Vídeo para Vídeo (Vid2Vid)?',
                        answer: 'Vídeo‑para‑Vídeo é um processo de IA generativa que usa um vídeo existente como entrada e o “repinta” em um novo estilo descrito pelo seu prompt, preservando o movimento e a estrutura originais.',
                    },
                    {
                        question: 'Posso transformar meu vídeo em estilo anime?',
                        answer: 'Sim! É o caso de uso mais popular. Envie seu vídeo e use prompts como “anime japonês, estilo Studio Ghibli” para transformar a filmagem.',
                    },
                    {
                        question: 'Qual pode ser a duração do vídeo de origem?',
                        answer: 'Atualmente suportamos/indicamos clipes curtos (por exemplo, 5–10 segundos) para garantir a melhor qualidade. Para vídeos longos, recomendamos dividir em segmentos.',
                    },
                    {
                        question: 'Isso é diferente de um editor de vídeo?',
                        answer: 'Sim. Um editor tradicional corta e trimma clipes. O Vídeo‑para‑Vídeo da WeryAI gera novos pixels, mudando completamente a textura e o estilo artístico do seu vídeo.',
                    },
                    {
                        question: 'Posso usar Video to Video de graça?',
                        answer: 'Novos usuários recebem créditos grátis ao se cadastrar — sem necessidade de cartão de crédito. Além disso, você pode ganhar mais créditos grátis com check-in diário, completando tarefas e convidando amigos, para continuar usando a transferência de estilo de vídeo sem pagar.',
                    },
                    {
                        question: 'Quais outras formas de criar vídeos com IA no WeryAI?',
                        answer: 'O WeryAI também oferece <a href="/text-to-video">Text to Video</a> para gerar vídeos a partir de textos e <a href="/image-to-video">Image to Video</a> para animar suas fotos. Todas as ferramentas compartilham os mesmos créditos diários gratuitos.',
                    },
                ],
            },
            faq: [
                {
                    question: 'O que é IA de Vídeo para Vídeo (Vid2Vid)?',
                    answer: 'Ele “repinta” um vídeo existente em um novo estilo via prompt, preservando movimento e estrutura.',
                },
                {
                    question: 'Posso transformar meu vídeo em estilo anime?',
                    answer: 'Sim. Use prompts como “anime japonês, estilo Studio Ghibli”.',
                },
                {
                    question: 'Qual pode ser a duração do vídeo de origem?',
                    answer: 'Recomendamos clipes curtos (5–10 s) para máxima qualidade; para longos, divida em segmentos.',
                },
                {
                    question: 'Isso é diferente de um editor de vídeo?',
                    answer: 'Editor corta; Vid2Vid gera novos pixels e muda textura/estilo do vídeo.',
                },
                {
                    question: 'Posso usar Video to Video de graça?',
                    answer: 'Ao se cadastrar, você recebe créditos grátis sem cartão de crédito. Ganhe mais com check-in diário, tarefas e convites de amigos para usar a transferência de estilo de vídeo continuamente grátis.',
                },
                {
                    question: 'Quais outras formas de criar vídeos com IA no WeryAI?',
                    answer: 'O WeryAI também oferece Text to Video para gerar vídeos a partir de textos e Image to Video para animar suas fotos. Todas as ferramentas compartilham os mesmos créditos diários gratuitos.',
                },
            ],
        },
    },
    it: {
        videoToVideo: {
            title: 'IA Video a Video Gratis: Trasferimento di Stile | WeryAI',
            description: 'Trasferimento di stile video con IA gratis — trasforma filmati in anime, arte 3D o cyberpunk in secondi. Movimento fluido, senza sfarfallio. Vid2Vid di WeryAI.',
            keywords: 'video a video AI, trasferimento stile video AI, vid2vid, trasformare video in anime AI, convertire video in anime, AI restyle video, filtro video AI, trasferimento stile video gratis online, WeryAI',
            og_title: 'IA Video a Video Gratis: Trasferimento di Stile | WeryAI',
            og_description: 'Trasferimento di stile video con IA gratis — trasforma filmati in anime, arte 3D o cyberpunk in secondi. Movimento fluido, senza sfarfallio. Vid2Vid di WeryAI.',
            twitter_title: 'IA Video a Video Gratis: Trasferimento di Stile | WeryAI',
            twitter_description: 'Trasferimento di stile video con IA gratis — trasforma filmati in anime, arte 3D o cyberpunk in secondi. Movimento fluido, senza sfarfallio. Vid2Vid di WeryAI.',
            page: {
                title1: 'Generatore Gratis AI Video→Video (Vid2Vid)',
                title2: 'Carica un video, scrivi uno stile e guarda la magia. La tecnologia Video→Video di WeryAI analizza il movimento del video sorgente e applica un nuovo stile artistico basato sul tuo prompt. Perfetto per edit anime, effetti claymation o arte visiva surreale.',
                feature_title1: 'Movimento Coerente',
                feature_desc1: 'A differenza della generazione standard, il nostro motore Vid2Vid si aggancia al movimento del video sorgente, garantendo transizioni fluide senza sfarfallii.',
                feature_title2: 'Da Reale ad Anime',
                feature_desc2: 'Lo strumento #1 per creator: trasformati in un personaggio anime o in un avatar 3D stile Pixar in un attimo.',
                feature_title3: 'Controllo con Prompt',
                feature_desc3: 'Hai il pieno controllo creativo. Scrivi “stile città cyberpunk” o “stile pittura a olio” per definire esattamente l’aspetto dell’output.',
                faq: [
                    {
                        question: 'Che cos’è l’AI Video→Video (Vid2Vid)?',
                        answer: 'Video→Video è un processo di AI generativa che usa un clip esistente come input e lo “ridipinge” in un nuovo stile descritto dal tuo prompt, preservando movimento e struttura originali.',
                    },
                    {
                        question: 'Posso trasformare il mio video in stile anime?',
                        answer: 'Sì! È il caso d’uso più popolare. Carica il video e inserisci prompt come “anime giapponese, stile Studio Ghibli” per trasformarlo.',
                    },
                    {
                        question: 'Quanto può essere lungo il video sorgente?',
                        answer: 'Al momento supportiamo/consigliamo clip brevi (ad es. 5–10 secondi) per garantire la massima qualità. Per video lunghi, consigliamo di dividerli in segmenti.',
                    },
                    {
                        question: 'È diverso da un editor video?',
                        answer: 'Sì. Un editor tradizionale taglia e rifila clip. Video→Video di WeryAI genera nuovi pixel, cambiando completamente texture e stile artistico del filmato.',
                    },
                    {
                        question: 'Posso usare Video to Video gratuitamente?',
                        answer: 'I nuovi utenti ricevono crediti gratuiti al momento della registrazione, senza bisogno di carta di credito. Inoltre, puoi guadagnare altri crediti gratuiti con il check-in giornaliero, completando attività e invitando amici, per continuare a usare il trasferimento di stile video senza mai pagare.',
                    },
                    {
                        question: 'Quali altri modi ci sono per creare video AI su WeryAI?',
                        answer: 'WeryAI offre anche <a href="/text-to-video">Text to Video</a> per generare video da testi scritti e <a href="/image-to-video">Image to Video</a> per animare le tue foto. Tutti gli strumenti condividono gli stessi crediti giornalieri gratuiti.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Che cos’è l’AI Video→Video (Vid2Vid)?',
                    answer: '“Ridipinge” un video esistente in un nuovo stile via prompt, preservando movimento e struttura.',
                },
                {
                    question: 'Posso trasformare il mio video in stile anime?',
                    answer: 'Sì. Prova prompt come “anime giapponese, stile Studio Ghibli”.',
                },
                {
                    question: 'Quanto può essere lungo il video sorgente?',
                    answer: 'Consigliamo clip brevi (5–10 s) per massima qualità; per lunghi, dividi in segmenti.',
                },
                {
                    question: 'È diverso da un editor video?',
                    answer: 'Un editor taglia; Vid2Vid genera nuovi pixel e cambia texture/stile.',
                },
                {
                    question: 'Posso usare Video to Video gratuitamente?',
                    answer: 'Crediti gratuiti alla registrazione, senza carta di credito. Guadagna di più con check-in giornaliero, attività e inviti di amici per il trasferimento di stile video gratuito continuo.',
                },
                {
                    question: 'Quali altri modi ci sono per creare video AI su WeryAI?',
                    answer: 'WeryAI offre anche Text to Video per generare video da testi scritti e Image to Video per animare le tue foto. Tutti gli strumenti condividono gli stessi crediti giornalieri gratuiti.',
                },
            ],
        },
    },
    ar: {
        videoToVideo: {
            title: 'AI فيديو إلى فيديو مجانًا: نقل الأسلوب | WeryAI',
            description: 'نقل أسلوب الفيديو بالذكاء الاصطناعي مجانًا — حوّل اللقطات إلى anime أو فن 3D أو cyberpunk في ثوانٍ. حركة سلسة، بدون وميض. Vid2Vid أونلاين من WeryAI.',
            keywords: 'فيديو إلى فيديو AI, نقل أسلوب الفيديو AI, vid2vid, تحويل فيديو إلى anime, تحويل فيديو إلى أنمي, إعادة أسلوب فيديو AI, فلتر فيديو AI, نقل أسلوب فيديو مجاني أونلاين, WeryAI',
            og_title: 'AI فيديو إلى فيديو مجانًا: نقل الأسلوب | WeryAI',
            og_description: 'نقل أسلوب الفيديو بالذكاء الاصطناعي مجانًا — حوّل اللقطات إلى anime أو فن 3D أو cyberpunk في ثوانٍ. حركة سلسة، بدون وميض. Vid2Vid أونلاين من WeryAI.',
            twitter_title: 'AI فيديو إلى فيديو مجانًا: نقل الأسلوب | WeryAI',
            twitter_description: 'نقل أسلوب الفيديو بالذكاء الاصطناعي مجانًا — حوّل اللقطات إلى anime أو فن 3D أو cyberpunk في ثوانٍ. حركة سلسة، بدون وميض. Vid2Vid أونلاين من WeryAI.',
            page: {
                title1: 'مولّد تحويل الفيديو إلى فيديو بالذكاء الاصطناعي مجانًا (Vid2Vid)',
                title2: 'ارفع فيديو، اكتب الأسلوب، وشاهد السحر يحدث. تحلل تقنية Video‑to‑Video من WeryAI حركة فيديو المصدر وتطبّق أسلوبًا فنيًا جديدًا بالكامل بناءً على مطالبتك النصية. مثالي لعمل تعديلات أنمي، تأثيرات claymation، أو فن بصري سريالي.',
                feature_title1: 'حركة متسقة',
                feature_desc1: 'على عكس التوليد القياسي، يثبت محرك Vid2Vid لدينا حركة الفيديو المصدر ليضمن انتقالات سلسة بدون وميض.',
                feature_title2: 'من الواقعي إلى الأنمي',
                feature_desc2: 'الأداة رقم 1 لصنّاع المحتوى: حوّل نفسك إلى شخصية أنمي أو أفاتار ثلاثي الأبعاد بأسلوب Pixar فورًا.',
                feature_title3: 'تحكم بالمطالبة',
                feature_desc3: 'لديك تحكم إبداعي كامل. اكتب "أسلوب مدينة سايبربانك" أو "أسلوب لوحة زيتية" لتحديد شكل الإخراج بدقة.',
                faq: [
                    {
                        question: 'ما هو تحويل الفيديو إلى فيديو بالذكاء الاصطناعي (Vid2Vid)؟',
                        answer: 'هو عملية ذكاء اصطناعي توليدية تأخذ مقطع فيديو موجودًا كمدخل وتُعيد "تلوينه" بأسلوب جديد تصفه مطالبتك النصية، مع الحفاظ على الحركة والبنية الأصلية.',
                    },
                    {
                        question: 'هل يمكنني تحويل الفيديو إلى أسلوب أنمي؟',
                        answer: 'نعم! هذا أشهر استخدام. ارفع الفيديو واكتب مطالبات مثل "أنمي ياباني، أسلوب Studio Ghibli" لتحويله.',
                    },
                    {
                        question: 'ما أقصى مدة لفيديو المصدر؟',
                        answer: 'حاليًا ندعم مقاطع قصيرة (مثل 5–10 ثوانٍ) لضمان أعلى جودة. للفيديوهات الأطول، نوصي بتقسيمها إلى مقاطع.',
                    },
                    {
                        question: 'هل يختلف عن محرر الفيديو؟',
                        answer: 'نعم. محرر الفيديو التقليدي يقتص ويقص المقاطع. أما Video‑to‑Video من WeryAI فيولّد بكسلات جديدة ويغيّر نسيج وأسلوب الفيديو بالكامل.',
                    },
                    {
                        question: 'هل يمكنني استخدام Video to Video مجاناً؟',
                        answer: 'يحصل المستخدمون الجدد على أرصدة مجانية عند التسجيل، دون الحاجة لبطاقة ائتمان. بالإضافة إلى ذلك، يمكنك كسب المزيد من الأرصدة المجانية من خلال تسجيل الدخول اليومي وإكمال المهام ودعوة الأصدقاء، لتستمر في استخدام نقل أسلوب الفيديو مجانًا.',
                    },
                    {
                        question: 'ما الطرق الأخرى لإنشاء فيديوهات AI على WeryAI؟',
                        answer: 'يقدم WeryAI أيضًا <a href="/text-to-video">Text to Video</a> لإنشاء فيديوهات من نصوص مكتوبة و<a href="/image-to-video">Image to Video</a> لتحريك صورك. تتشارك جميع الأدوات نفس الأرصدة اليومية المجانية.',
                    },
                ],
            },
            faq: [
                {
                    question: 'ما هو تحويل الفيديو إلى فيديو بالذكاء الاصناعي (Vid2Vid)؟',
                    answer: 'يعيد "تلوين" فيديو موجود بأسلوب جديد عبر مطالبة نصية مع الحفاظ على الحركة والبنية.',
                },
                {
                    question: 'هل يمكنني تحويل الفيديو إلى أسلوب أنمي؟',
                    answer: 'نعم. جرّب مطالبات مثل "أنمي ياباني، Studio Ghibli".',
                },
                {
                    question: 'ما أقصى مدة لفيديو المصدر؟',
                    answer: 'نوصي بمقاطع قصيرة (5–10 ثوانٍ) لأفضل جودة؛ للفيديوهات الأطول قسّمها لمقاطع.',
                },
                {
                    question: 'هل يختلف عن محرر الفيديو؟',
                    answer: 'المحرر يقتص؛ Vid2Vid يولّد بكسلات جديدة ويغيّر النسيج/الأسلوب.',
                },
                {
                    question: 'هل يمكنني استخدام Video to Video مجاناً؟',
                    answer: 'أرصدة مجانية عند التسجيل دون بطاقة ائتمان. اكسب المزيد عبر تسجيل الدخول اليومي والمهام ودعوة الأصدقاء لاستخدام نقل أسلوب الفيديو مجانًا باستمرار.',
                },
                {
                    question: 'ما الطرق الأخرى لإنشاء فيديوهات AI على WeryAI؟',
                    answer: 'يقدم WeryAI أيضًا Text to Video لإنشاء فيديوهات من نصوص مكتوبة وImage to Video لتحريك صورك. تتشارك جميع الأدوات نفس الأرصدة اليومية المجانية.',
                },
            ],
        },
    },
    tw: {
        videoToVideo: {
            title: '免費 AI 影片轉影片：風格遷移 | WeryAI',
            description: '免費 AI 影片風格遷移——秒變 anime、3D 藝術或 cyberpunk，動作流暢無閃爍。WeryAI 線上 Vid2Vid。',
            keywords: '影片轉影片 AI, AI 影片風格遷移, vid2vid, 影片變 anime, 影片轉動漫, AI 影片重風格, 影片濾鏡 AI, 免費線上影片風格遷移, WeryAI',
            og_title: '免費 AI 影片轉影片：風格遷移 | WeryAI',
            og_description: '免費 AI 影片風格遷移——秒變 anime、3D 藝術或 cyberpunk，動作流暢無閃爍。WeryAI 線上 Vid2Vid。',
            twitter_title: '免費 AI 影片轉影片：風格遷移 | WeryAI',
            twitter_description: '免費 AI 影片風格遷移——秒變 anime、3D 藝術或 cyberpunk，動作流暢無閃爍。WeryAI 線上 Vid2Vid。',
            page: {
                title1: '免費 AI 影片轉影片生成器（Vid2Vid）',
                title2: '上傳影片、輸入風格，看見魔法發生。WeryAI 的影片轉影片技術會分析原片段的動作，並依照你的文字提示套用全新的藝術風格。非常適合做動漫剪輯、黏土動畫效果或超現實視覺藝術。',
                feature_title1: '動作一致性',
                feature_desc1: '不同於一般生成，我們的 Vid2Vid 引擎會鎖定原始影片的運動，確保轉場順滑、不易閃爍。',
                feature_title2: '真人變動漫',
                feature_desc2: '內容創作者首選：一鍵把自己變成動漫角色或 3D 皮克斯風格形象。',
                feature_title3: '提示詞控制',
                feature_desc3: '你擁有完整創作控制權。只要輸入「賽博龐克城市風格」或「油畫風格」，即可定義輸出視覺。',
                faq: [
                    {
                        question: '什麼是 AI 影片轉影片（Vid2Vid）？',
                        answer: '影片轉影片是一種生成式 AI 流程：以現有影片片段為輸入，依你的文字提示「重繪」成新風格，同時保留原始動作與結構。',
                    },
                    {
                        question: '我可以把影片變成動漫風格嗎？',
                        answer: '可以！這是最熱門的用途。上傳影片後輸入「日系動漫風格、吉卜力畫風」等提示詞即可轉換。',
                    },
                    {
                        question: '來源影片最長可以多長？',
                        answer: '目前為了最佳品質，較適合短片段（例如 5–10 秒）。較長影片建議分段處理。',
                    },
                    {
                        question: '它和傳統影片剪輯軟體不同嗎？',
                        answer: '是的。傳統剪輯是裁切與拼接；WeryAI 影片轉影片會生成新像素，徹底改變素材的紋理與藝術風格。',
                    },
                    {
                        question: '影片轉影片功能可以免費使用嗎？',
                        answer: '新用戶註冊即可獲得免費點數，無需綁定信用卡。此外，你還可以透過每日簽到、完成任務和邀請好友持續獲取免費點數，讓你無需付費即可持續體驗影片轉影片功能。',
                    },
                    {
                        question: '在 WeryAI 上還有哪些方式可以創建 AI 影片？',
                        answer: 'WeryAI 還提供 <a href="/text-to-video">Text to Video</a>（根據文字提示生成影片）和 <a href="/image-to-video">Image to Video</a>（將照片動畫化）。所有工具共享相同的每日免費點數。',
                    },
                ],
            },
            faq: [
                {
                    question: '什麼是 AI 影片轉影片（Vid2Vid）？',
                    answer: '影片轉影片是一種生成式 AI 流程：以現有影片片段為輸入，依你的文字提示重繪成新風格，同時保留原始動作與結構。',
                },
                {
                    question: '我可以把影片變成動漫風格嗎？',
                    answer: '可以！上傳影片後輸入「日系動漫風格、吉卜力畫風」等提示詞即可轉換。',
                },
                {
                    question: '來源影片最長可以多長？',
                    answer: '較適合短片段（例如 5–10 秒）以確保品質；較長影片建議分段處理。',
                },
                {
                    question: '它和傳統影片剪輯軟體不同嗎？',
                    answer: '傳統剪輯是裁切與拼接；影片轉影片會生成新像素，改變素材的紋理與藝術風格。',
                },
                {
                    question: '影片轉影片功能可以免費使用嗎？',
                    answer: '註冊即可獲得免費點數，無需綁定信用卡。透過每日簽到、完成任務和邀請好友可持續獲取免費點數，暢享影片轉影片功能。',
                },
                {
                    question: '在 WeryAI 上還有哪些方式可以創建 AI 影片？',
                    answer: 'WeryAI 還提供 Text to Video（根據文字提示生成影片）和 Image to Video（將照片動畫化）。所有工具共享相同的每日免費點數。',
                },
            ],
        },
    },
    pl: {
        videoToVideo: {
            title: 'Darmowe AI Wideo do Wideo: Transfer Stylu | WeryAI',
            description: 'Darmowy transfer stylu wideo z AI — zamień nagrania w anime, sztukę 3D lub cyberpunk w kilka sekund. Płynny ruch, bez migotania. Online Vid2Vid od WeryAI.',
            keywords: 'wideo do wideo AI, AI transfer stylu wideo, vid2vid, zamienić wideo w anime AI, konwersja wideo na anime, AI restylizacja wideo, filtr wideo AI, darmowy transfer stylu wideo online, WeryAI',
            og_title: 'Darmowe AI Wideo do Wideo: Transfer Stylu | WeryAI',
            og_description: 'Darmowy transfer stylu wideo z AI — zamień nagrania w anime, sztukę 3D lub cyberpunk w kilka sekund. Płynny ruch, bez migotania. Online Vid2Vid od WeryAI.',
            twitter_title: 'Darmowe AI Wideo do Wideo: Transfer Stylu | WeryAI',
            twitter_description: 'Darmowy transfer stylu wideo z AI — zamień nagrania w anime, sztukę 3D lub cyberpunk w kilka sekund. Płynny ruch, bez migotania. Online Vid2Vid od WeryAI.',
            page: {
                title1: 'Darmowy generator AI wideo→wideo (Vid2Vid)',
                title2: 'Prześlij wideo, wpisz styl i zobacz magię. Technologia WeryAI Video to Video analizuje ruch z materiału źródłowego i nakłada zupełnie nowy styl na podstawie Twojego promptu. Idealne do anime editów, efektu plasteliny lub surrealistycznej sztuki.',
                feature_title1: 'Spójny ruch',
                feature_desc1: 'W przeciwieństwie do zwykłej generacji nasz silnik Vid2Vid śledzi ruch w źródłowym wideo, zapewniając płynne przejścia bez migotania.',
                feature_title2: 'Real → Anime',
                feature_desc2: 'Narzędzie nr 1 dla twórców. Zmień się w postać anime lub w avatara 3D w stylu Pixara.',
                feature_title3: 'Kontrola promptu',
                feature_desc3: 'Masz pełną kontrolę twórczą. Wpisz np. "styl cyberpunkowego miasta" lub "styl malarstwa olejnego", aby zdefiniować wygląd wyjścia.',
                faq: [
                    {
                        question: 'Czym jest AI Video to Video (Vid2Vid)?',
                        answer: 'Video to Video to proces generatywnej AI, który bierze istniejący klip jako wejście i "przemalowuje" go na nowy styl opisany w promptcie, zachowując oryginalny ruch i strukturę.',
                    },
                    {
                        question: 'Czy mogę zamienić wideo w styl anime?',
                        answer: 'Tak! To najpopularniejsze zastosowanie. Prześlij wideo i wpisz prompty typu "japoński styl anime, Studio Ghibli", aby je przekształcić.',
                    },
                    {
                        question: 'Jak długi może być film źródłowy?',
                        answer: 'Obecnie najlepiej sprawdzają się krótkie klipy (np. 5–10 sekund), aby zapewnić najwyższą jakość transferu stylu. Dłuższe filmy warto dzielić na segmenty.',
                    },
                    {
                        question: 'Czy to różni się od edytora wideo?',
                        answer: 'Tak. Tradycyjny edytor tnie i przycina klipy. WeryAI Video to Video generuje nowe piksele, całkowicie zmieniając teksturę i styl artystyczny materiału.',
                    },
                    {
                        question: 'Czy mogę korzystać z Video to Video za darmo?',
                        answer: 'Nowi użytkownicy otrzymują darmowe kredyty przy rejestracji — bez karty kredytowej. Dodatkowo możesz zdobywać więcej darmowych kredytów poprzez codzienne logowanie, wykonywanie zadań i zapraszanie znajomych, aby korzystać z transferu stylu wideo za darmo bez przerwy.',
                    },
                    {
                        question: 'Jakie inne sposoby tworzenia filmów AI są dostępne na WeryAI?',
                        answer: 'WeryAI oferuje również <a href="/text-to-video">Text to Video</a> do generowania filmów z tekstów i <a href="/image-to-video">Image to Video</a> do animowania zdjęć. Wszystkie narzędzia współdzielą te same darmowe dzienne kredyty.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Czym jest AI Video to Video (Vid2Vid)?',
                    answer: 'Video to Video to proces generatywnej AI, który bierze istniejący klip i "przemalowuje" go na nowy styl zgodnie z promptem, zachowując ruch i strukturę.',
                },
                {
                    question: 'Czy mogę zamienić wideo w styl anime?',
                    answer: 'Tak! Prześlij wideo i użyj promptów typu "japoński styl anime, Studio Ghibli".',
                },
                {
                    question: 'Jak długi może być film źródłowy?',
                    answer: 'Najlepiej sprawdzają się krótkie klipy (np. 5–10 sekund); dłuższe filmy warto dzielić.',
                },
                {
                    question: 'Czy to różni się od edytora wideo?',
                    answer: 'Tradycyjny edytor tnie i przycina, a Video to Video generuje nowe piksele i zmienia styl materiału.',
                },
                {
                    question: 'Czy mogę korzystać z Video to Video za darmo?',
                    answer: 'Darmowe kredyty przy rejestracji, bez karty kredytowej. Zdobywaj więcej przez codzienne logowanie, zadania i zapraszanie znajomych, aby korzystać z transferu stylu wideo za darmo.',
                },
                {
                    question: 'Jakie inne sposoby tworzenia filmów AI są dostępne na WeryAI?',
                    answer: 'WeryAI oferuje również Text to Video do generowania filmów z tekstów i Image to Video do animowania zdjęć. Wszystkie narzędzia współdzielą te same darmowe dzienne kredyty.',
                },
            ],
        },
    },
    th: {
        videoToVideo: {
            title: 'AI วิดีโอเป็นวิดีโอฟรี: ถ่ายโอนสไตล์ | WeryAI',
            description: 'ถ่ายโอนสไตล์วิดีโอด้วย AI ฟรี — เปลี่ยนฟุตเทจเป็น anime, งาน 3D หรือ cyberpunk ในไม่กี่วินาที การเคลื่อนไหวลื่น ไม่กะพริบ Vid2Vid ออนไลน์โดย WeryAI',
            keywords: 'วิดีโอเป็นวิดีโอ AI, AI ถ่ายโอนสไตล์วิดีโอ, vid2vid, แปลงวิดีโอเป็น anime, วิดีโอเป็นอนิเมะ, AI รีสไตล์วิดีโอ, ฟิลเตอร์วิดีโอ AI, ถ่ายโอนสไตล์วิดีโอฟรีออนไลน์, WeryAI',
            og_title: 'AI วิดีโอเป็นวิดีโอฟรี: ถ่ายโอนสไตล์ | WeryAI',
            og_description: 'ถ่ายโอนสไตล์วิดีโอด้วย AI ฟรี — เปลี่ยนฟุตเทจเป็น anime, งาน 3D หรือ cyberpunk ในไม่กี่วินาที การเคลื่อนไหวลื่น ไม่กะพริบ Vid2Vid ออนไลน์โดย WeryAI',
            twitter_title: 'AI วิดีโอเป็นวิดีโอฟรี: ถ่ายโอนสไตล์ | WeryAI',
            twitter_description: 'ถ่ายโอนสไตล์วิดีโอด้วย AI ฟรี — เปลี่ยนฟุตเทจเป็น anime, งาน 3D หรือ cyberpunk ในไม่กี่วินาที การเคลื่อนไหวลื่น ไม่กะพริบ Vid2Vid ออนไลน์โดย WeryAI',
            page: {
                title1: 'เครื่องมือสร้างวิดีโอเป็นวิดีโอด้วย AI ฟรี (Vid2Vid)',
                title2: 'อัปโหลดวิดีโอ พิมพ์สไตล์ แล้วดูเวทมนตร์เกิดขึ้น เทคโนโลยี Video to Video ของ WeryAI จะวิเคราะห์การเคลื่อนไหวจากวิดีโอต้นฉบับ และใส่สไตล์ศิลปะใหม่ตามพรอมต์ของคุณ เหมาะสำหรับทำคลิปอนิเมะ เอฟเฟกต์สต็อปโมชัน หรือศิลปะแนวเหนือจริง',
                feature_title1: 'การเคลื่อนไหวสม่ำเสมอ',
                feature_desc1: 'ต่างจากการสร้างทั่วไป เอนจิน Vid2Vid ของเรายึดการเคลื่อนไหวจากวิดีโอต้นฉบับ ทำให้การเปลี่ยนเฟรมลื่นไหลและไม่กะพริบ',
                feature_title2: 'จากของจริงเป็นอนิเมะ',
                feature_desc2: 'เครื่องมือยอดนิยมสำหรับครีเอเตอร์ เปลี่ยนตัวคุณให้เป็นตัวละครอนิเมะหรืออวตาร 3D สไตล์พิกซาร์ได้ทันที',
                feature_title3: 'ควบคุมด้วยพรอมต์',
                feature_desc3: 'คุณควบคุมงานสร้างสรรค์ได้เต็มที่ แค่พิมพ์ “สไตล์เมืองไซเบอร์พังก์” หรือ “สไตล์ภาพสีน้ำมัน” ก็ได้ลุคที่ต้องการ',
                faq: [
                    {
                        question: 'AI วิดีโอเป็นวิดีโอ (Vid2Vid) คืออะไร?',
                        answer: 'Video to Video คือกระบวนการ AI เชิงสร้างสรรค์ที่ใช้คลิปวิดีโอเดิมเป็นอินพุต แล้ว “วาดใหม่” ให้เป็นสไตล์ตามพรอมต์ พร้อมคงการเคลื่อนไหวและโครงสร้างเดิม',
                    },
                    {
                        question: 'สามารถเปลี่ยนวิดีโอเป็นสไตล์อนิเมะได้ไหม?',
                        answer: 'ได้! นี่คือการใช้งานยอดนิยม เพียงอัปโหลดวิดีโอและใส่พรอมต์ เช่น “อนิเมะญี่ปุ่น, สไตล์สตูดิโอจิบลิ”',
                    },
                    {
                        question: 'วิดีโอต้นฉบับยาวได้เท่าไร?',
                        answer: 'ปัจจุบันเหมาะกับคลิปสั้น (เช่น 5–10 วินาที) เพื่อคุณภาพการถ่ายโอนสไตล์สูงสุด สำหรับวิดีโอยาว แนะนำแบ่งเป็นช่วง',
                    },
                    {
                        question: 'ต่างจากโปรแกรมตัดต่อวิดีโออย่างไร?',
                        answer: 'ต่างกัน โปรแกรมตัดต่อแบบเดิมคือการตัดและเรียงคลิป ส่วน WeryAI Video to Video จะสร้างพิกเซลใหม่และเปลี่ยนสไตล์ศิลป์ของฟุตเทจทั้งหมด',
                    },
                    {
                        question: 'ใช้ Video to Video ได้ฟรีไหม?',
                        answer: 'ผู้ใช้ใหม่จะได้รับเครดิตฟรีเมื่อสมัครสมาชิก ไม่ต้องผูกบัตรเครดิต นอกจากนี้ยังสามารถรับเครดิตฟรีเพิ่มเติมผ่านการเช็คอินรายวัน ทำภารกิจ และเชิญเพื่อน เพื่อใช้งานการถ่ายโอนสไตล์วิดีโอได้ฟรีอย่างต่อเนื่อง',
                    },
                    {
                        question: 'มีวิธีอื่นใดบ้างในการสร้างวิดีโอ AI บน WeryAI?',
                        answer: 'WeryAI ยังมี <a href="/text-to-video">Text to Video</a> สำหรับสร้างวิดีโอจากข้อความ และ <a href="/image-to-video">Image to Video</a> สำหรับทำรูปภาพให้เคลื่อนไหว เครื่องมือทั้งหมดใช้เครดิตฟรีรายวันเดียวกัน',
                    },
                ],
            },
            faq: [
                {
                    question: 'AI วิดีโอเป็นวิดีโอ (Vid2Vid) คืออะไร?',
                    answer: 'Video to Video คือกระบวนการ AI ที่ใช้คลิปเดิมเป็นอินพุตแล้ววาดใหม่ตามพรอมต์ โดยคงการเคลื่อนไหวและโครงสร้างเดิม',
                },
                {
                    question: 'สามารถเปลี่ยนวิดีโอเป็นสไตล์อนิเมะได้ไหม?',
                    answer: 'ได้ เพียงอัปโหลดวิดีโอและใช้พรอมต์ เช่น “อนิเมะญี่ปุ่น, สไตล์สตูดิโอจิบลิ”',
                },
                {
                    question: 'วิดีโอต้นฉบับยาวได้เท่าไร?',
                    answer: 'เหมาะกับคลิปสั้น (เช่น 5–10 วินาที) เพื่อคุณภาพที่ดีที่สุด; วิดีโอยาวแนะนำแบ่งเป็นช่วง',
                },
                {
                    question: 'ต่างจากโปรแกรมตัดต่อวิดีโออย่างไร?',
                    answer: 'โปรแกรมตัดต่อคือการตัดต่อคลิป ส่วน Video to Video สร้างพิกเซลใหม่และเปลี่ยนสไตล์ของฟุตเทจ',
                },
                {
                    question: 'ใช้ Video to Video ได้ฟรีไหม?',
                    answer: 'สมัครสมาชิกรับเครดิตฟรีทันที ไม่ต้องผูกบัตรเครดิต รับเครดิตเพิ่มผ่านเช็คอินรายวัน ทำภารกิจ และเชิญเพื่อน เพื่อใช้การถ่ายโอนสไตล์วิดีโอฟรีต่อเนื่อง',
                },
                {
                    question: 'มีวิธีอื่นใดบ้างในการสร้างวิดีโอ AI บน WeryAI?',
                    answer: 'WeryAI ยังมี Text to Video สำหรับสร้างวิดีโอจากข้อความ และ Image to Video สำหรับทำรูปภาพให้เคลื่อนไหว เครื่องมือทั้งหมดใช้เครดิตฟรีรายวันเดียวกัน',
                },
            ],
        },
    },
    da: {
        videoToVideo: {
            title: 'Gratis AI Video til Video: Stil-overførsel | WeryAI',
            description: 'Gratis AI video-stil-overførsel — lav optagelser om til anime, 3D-kunst eller cyberpunk på sekunder. Flydende bevægelse, ingen flimren. Vid2Vid fra WeryAI.',
            keywords: 'video til video AI, AI video-stil-overførsel, vid2vid, gør video til anime AI, konverter video til anime, AI video restyle, videofilter AI, gratis video-stil-overførsel online, WeryAI',
            og_title: 'Gratis AI Video til Video: Stil-overførsel | WeryAI',
            og_description: 'Gratis AI video-stil-overførsel — lav optagelser om til anime, 3D-kunst eller cyberpunk på sekunder. Flydende bevægelse, ingen flimren. Vid2Vid fra WeryAI.',
            twitter_title: 'Gratis AI Video til Video: Stil-overførsel | WeryAI',
            twitter_description: 'Gratis AI video-stil-overførsel — lav optagelser om til anime, 3D-kunst eller cyberpunk på sekunder. Flydende bevægelse, ingen flimren. Vid2Vid fra WeryAI.',
            page: {
                title1: 'Gratis AI video-til-video generator (Vid2Vid)',
                title2: `Upload en video, skriv en stil, og se magien ske. WeryAI's Video to Video-teknologi analyserer bevægelsen i dit kildemateriale og anvender en helt ny kunstnerisk stil baseret på din tekstprompt. Perfekt til anime-edits, claymation-effekter eller surrealistisk visuel kunst.`,
                feature_title1: 'Konsistent bevægelse',
                feature_desc1: 'I modsætning til standardgenerering låser vores Vid2Vid-motor sig fast på bevægelsen i din kildevideo og sikrer glatte overgange uden flimmer.',
                feature_title2: 'Real til anime',
                feature_desc2: '#1 værktøj for content creators. Forvandl dig selv til en animefigur eller en 3D Pixar-lignende avatar med det samme.',
                feature_title3: 'Prompt-kontrol',
                feature_desc3: 'Du har fuld kreativ kontrol. Skriv fx "cyberpunk-by stil" eller "oliemaleri-stil" for at definere udseendet præcist.',
                faq: [
                    {
                        question: 'Hvad er AI Video to Video (Vid2Vid)?',
                        answer: 'Video to Video er en generativ AI-proces, der tager et eksisterende videoklip som input og "genmaler" det i en ny stil beskrevet af din tekstprompt, mens den originale bevægelse og struktur bevares.',
                    },
                    {
                        question: 'Kan jeg gøre min video til en anime-stil?',
                        answer: 'Ja! Det er den mest populære use case. Upload din video og skriv prompts som "japansk anime-stil, Studio Ghibli-look" for at transformere optagelsen.',
                    },
                    {
                        question: 'Hvor lang må kildevideoen være?',
                        answer: 'I øjeblikket understøtter vi korte klip (fx op til 5–10 sekunder) for at sikre den højeste kvalitet. Længere videoer anbefales delt i segmenter.',
                    },
                    {
                        question: 'Er det anderledes end en videoredigerer?',
                        answer: 'Ja. En traditionel videoredigerer klipper og trimmer klip. WeryAI Video to Video genererer nye pixels og ændrer hele teksturen og den kunstneriske stil i dit materiale.',
                    },
                    {
                        question: 'Kan jeg bruge Video to Video gratis?',
                        answer: 'Nye brugere får gratis credits ved tilmelding — intet kreditkort påkrævet. Derudover kan du optjene flere gratis credits via daglig check-in, udførelse af opgaver og invitation af venner, så du kan fortsætte med at bruge videostil-overførsel helt gratis.',
                    },
                    {
                        question: 'Hvilke andre måder kan jeg lave AI-videoer på WeryAI?',
                        answer: 'WeryAI tilbyder også <a href="/text-to-video">Text to Video</a> til at generere videoer fra tekst og <a href="/image-to-video">Image to Video</a> til at animere dine fotos. Alle værktøjer deler de samme daglige gratis credits.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Hvad er AI Video to Video (Vid2Vid)?',
                    answer: 'Video to Video er en generativ AI-proces, der tager et eksisterende videoklip og genmaler det i en ny stil baseret på din prompt, mens bevægelse og struktur bevares.',
                },
                {
                    question: 'Kan jeg gøre min video til en anime-stil?',
                    answer: 'Ja! Upload din video og brug prompts som "japansk anime-stil, Studio Ghibli-look".',
                },
                {
                    question: 'Hvor lang må kildevideoen være?',
                    answer: 'Vi understøtter bedst korte klip (fx 5–10 sekunder); længere videoer bør deles op.',
                },
                {
                    question: 'Er det anderledes end en videoredigerer?',
                    answer: 'En videoredigerer klipper og trimmer; Video to Video genererer nye pixels og ændrer stilen.',
                },
                {
                    question: 'Kan jeg bruge Video to Video gratis?',
                    answer: 'Gratis credits ved tilmelding, intet kreditkort nødvendigt. Optjen flere via daglig check-in, opgaver og invitation af venner for fortsat gratis videostil-overførsel.',
                },
                {
                    question: 'Hvilke andre måder kan jeg lave AI-videoer på WeryAI?',
                    answer: 'WeryAI tilbyder også Text to Video til at generere videoer fra tekst og Image to Video til at animere dine fotos. Alle værktøjer deler de samme daglige gratis credits.',
                },
            ],
        },
    },
    no: {
        videoToVideo: {
            title: 'Gratis AI Video til Video: Stil-overføring | WeryAI',
            description: 'Gratis AI video-stil-overføring — gjør opptak om til anime, 3D-kunst eller cyberpunk på sekunder. Jevn bevegelse, ingen flimring. Online Vid2Vid fra WeryAI.',
            keywords: 'video til video ai, vid2vid, ai videostiloverføring, gjør video til anime, ai videorestyle, gratis ai videofilter',
            og_title: 'Gratis AI Video til Video: Stil-overføring | WeryAI',
            og_description: 'Gratis AI video-stil-overføring — gjør opptak om til anime, 3D-kunst eller cyberpunk på sekunder. Jevn bevegelse, ingen flimring. Online Vid2Vid fra WeryAI.',
            twitter_title: 'Gratis AI Video til Video: Stil-overføring | WeryAI',
            twitter_description: 'Gratis AI video-stil-overføring — gjør opptak om til anime, 3D-kunst eller cyberpunk på sekunder. Jevn bevegelse, ingen flimring. Online Vid2Vid fra WeryAI.',
            page: {
                title1: 'Gratis AI video-til-video-generator (Vid2Vid)',
                title2: 'Last opp en video, skriv inn en stil, og se magien skje. WeryAI sin Video to Video-teknologi analyserer bevegelsen i kildematerialet og legger på en helt ny kunstnerisk stil basert på tekstprompten din. Perfekt for anime-edits, claymation-effekter eller surrealistisk visuell kunst.',
                feature_title1: 'Konsistent bevegelse',
                feature_desc1: 'I motsetning til vanlig generering låser Vid2Vid-motoren vår seg til bevegelsen i kildevideoen, noe som gir jevne overganger uten flimring.',
                feature_title2: 'Real til anime',
                feature_desc2: '#1-verktøyet for skapere. Gjør deg selv om til en animefigur eller en 3D Pixar-stil avatar på et øyeblikk.',
                feature_title3: 'Prompt-kontroll',
                feature_desc3: 'Du har full kreativ kontroll. Skriv for eksempel "cyberpunk-by stil" eller "oljemaleri-stil" for å definere nøyaktig utseende.',
                faq: [
                    {
                        question: 'Hva er AI Video to Video (Vid2Vid)?',
                        answer: 'Video to Video er en generativ AI-prosess som tar et eksisterende videoklipp som input og "maler" det om til en ny stil beskrevet av tekstprompten din, samtidig som den originale bevegelsen og strukturen bevares.',
                    },
                    {
                        question: 'Kan jeg gjøre videoen min om til anime-stil?',
                        answer: 'Ja! Dette er den mest populære bruken. Last opp videoen din og skriv prompts som "japansk anime-stil, Studio Ghibli-look" for å transformere klippet.',
                    },
                    {
                        question: 'Hvor lang kan kildevideoen være?',
                        answer: 'Per nå støtter vi korte klipp (f.eks. opptil 5–10 sekunder) for å sikre best mulig kvalitet. For lengre videoer anbefaler vi å dele dem opp.',
                    },
                    {
                        question: 'Er det annerledes enn en videoredigerer?',
                        answer: 'Ja. En tradisjonell videoredigerer klipper og trimmer klipp. WeryAI Video to Video genererer nye piksler og endrer tekstur og kunstnerisk stil fullstendig.',
                    },
                    {
                        question: 'Kan jeg bruke Video to Video gratis?',
                        answer: 'Nye brukere får gratis kreditter ved registrering — ingen kredittkort nødvendig. I tillegg kan du tjene flere gratis kreditter gjennom daglig innsjekking, fullføring av oppgaver og invitasjon av venner, slik at du kan fortsette å bruke videostil-overføring helt gratis.',
                    },
                    {
                        question: 'Hvilke andre måter kan jeg lage AI-videoer på WeryAI?',
                        answer: 'WeryAI tilbyr også <a href="/text-to-video">Text to Video</a> for å generere videoer fra tekst og <a href="/image-to-video">Image to Video</a> for å animere bildene dine. Alle verktøy deler de samme daglige gratis kredittene.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Hva er AI Video to Video (Vid2Vid)?',
                    answer: 'Video to Video er en generativ AI-prosess som tar et eksisterende videoklipp og maler det om til en ny stil basert på prompten, mens bevegelse og struktur bevares.',
                },
                {
                    question: 'Kan jeg gjøre videoen min om til anime-stil?',
                    answer: 'Ja! Last opp videoen og bruk prompts som "japansk anime-stil, Studio Ghibli-look".',
                },
                {
                    question: 'Hvor lang kan kildevideoen være?',
                    answer: 'Best for korte klipp (f.eks. 5–10 sekunder); lengre videoer bør deles opp.',
                },
                {
                    question: 'Er det annerledes enn en videoredigerer?',
                    answer: 'En videoredigerer klipper og trimmer; Video to Video genererer nye piksler og endrer stilen.',
                },
                {
                    question: 'Kan jeg bruke Video to Video gratis?',
                    answer: 'Gratis kreditter ved registrering, uten kredittkort. Tjen flere via daglig innsjekking, oppgaver og invitasjon av venner for fortløpende gratis videostil-overføring.',
                },
                {
                    question: 'Hvilke andre måter kan jeg lage AI-videoer på WeryAI?',
                    answer: 'WeryAI tilbyr også Text to Video for å generere videoer fra tekst og Image to Video for å animere bildene dine. Alle verktøy deler de samme daglige gratis kredittene.',
                },
            ],
        },
    },
    nl: {
        videoToVideo: {
            title: 'Gratis AI Video naar Video: Stijloverdracht | WeryAI',
            description: 'Gratis AI-videostijloverdracht — verander beeldmateriaal in anime, 3D-kunst of cyberpunk in seconden. Vloeiende beweging, geen flikkering. Vid2Vid van WeryAI.',
            keywords: 'video naar video AI, AI video-stijloverdracht, vid2vid, video naar anime AI, video in anime omzetten, AI video restyle, videofilter AI, gratis video-stijloverdracht online, WeryAI',
            og_title: 'Gratis AI Video naar Video: Stijloverdracht | WeryAI',
            og_description: 'Gratis AI-videostijloverdracht — verander beeldmateriaal in anime, 3D-kunst of cyberpunk in seconden. Vloeiende beweging, geen flikkering. Vid2Vid van WeryAI.',
            twitter_title: 'Gratis AI Video naar Video: Stijloverdracht | WeryAI',
            twitter_description: 'Gratis AI-videostijloverdracht — verander beeldmateriaal in anime, 3D-kunst of cyberpunk in seconden. Vloeiende beweging, geen flikkering. Vid2Vid van WeryAI.',
            page: {
                title1: 'Gratis AI video-naar-video generator (Vid2Vid)',
                title2: `Upload een video, typ een stijl en zie de magie gebeuren. WeryAI's Video to Video-technologie analyseert de beweging in je bronmateriaal en past een compleet nieuwe artistieke stijl toe op basis van je tekstprompt. Perfect voor anime-edits, claymation-effecten of surrealistische visuele kunst.`,
                feature_title1: 'Consistente beweging',
                feature_desc1: 'In tegenstelling tot standaardgeneratie verankert onze Vid2Vid-engine de beweging van je bronvideo, waardoor overgangen soepel blijven zonder flikkeren.',
                feature_title2: 'Van echt naar anime',
                feature_desc2: 'De #1 tool voor creators. Verander jezelf direct in een animepersonage of een 3D Pixar-achtige avatar.',
                feature_title3: 'Promptcontrole',
                feature_desc3: 'Je hebt volledige creatieve controle. Typ bijvoorbeeld "cyberpunk-stad stijl" of "olieverf-stijl" om de look precies te bepalen.',
                faq: [
                    {
                        question: 'Wat is AI Video to Video (Vid2Vid)?',
                        answer: 'Video to Video is een generatief AI-proces dat een bestaand videofragment als input neemt en het "overschildert" naar een nieuwe stijl die door je tekstprompt wordt beschreven, terwijl de originele beweging en structuur behouden blijven.',
                    },
                    {
                        question: 'Kan ik mijn video omzetten naar anime-stijl?',
                        answer: 'Ja! Dit is de populairste use case. Upload je video en gebruik prompts zoals "Japanse anime-stijl, Studio Ghibli-look" om je beelden te transformeren.',
                    },
                    {
                        question: 'Hoe lang mag de bronvideo zijn?',
                        answer: `Momenteel ondersteunen we korte clips (bijv. 5–10 seconden) om de hoogste kwaliteit te garanderen. Voor langere video's raden we aan ze op te splitsen.`,
                    },
                    {
                        question: 'Is dit anders dan een videobewerker?',
                        answer: 'Ja. Een traditionele videobewerker knipt en trimt clips. WeryAI Video to Video genereert nieuwe pixels en verandert de textuur en artistieke stijl volledig.',
                    },
                    {
                        question: 'Kan ik Video to Video gratis gebruiken?',
                        answer: 'Nieuwe gebruikers ontvangen gratis credits bij aanmelding — geen creditcard vereist. Bovendien kun je meer gratis credits verdienen via dagelijks inchecken, het voltooien van taken en het uitnodigen van vrienden, zodat je videostijloverdracht gratis kunt blijven gebruiken.',
                    },
                    {
                        question: 'Welke andere manieren zijn er om AI-video’s te maken op WeryAI?',
                        answer: 'WeryAI biedt ook <a href="/text-to-video">Text to Video</a> om video’s te genereren uit tekst en <a href="/image-to-video">Image to Video</a> om je foto’s te animeren. Alle tools delen dezelfde dagelijkse gratis credits.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Wat is AI Video to Video (Vid2Vid)?',
                    answer: 'Video to Video is een generatief AI-proces dat een bestaande clip "overschildert" naar een nieuwe stijl op basis van je prompt, met behoud van beweging en structuur.',
                },
                {
                    question: 'Kan ik mijn video omzetten naar anime-stijl?',
                    answer: 'Ja! Upload je video en gebruik prompts zoals "Japanse anime-stijl, Studio Ghibli-look".',
                },
                {
                    question: 'Hoe lang mag de bronvideo zijn?',
                    answer: `Korte clips (bijv. 5–10 seconden) werken het best; langere video's kun je opsplitsen.`,
                },
                {
                    question: 'Is dit anders dan een videobewerker?',
                    answer: 'Een videobewerker knipt en trimt; Video to Video genereert nieuwe pixels en verandert de stijl.',
                },
                {
                    question: 'Kan ik Video to Video gratis gebruiken?',
                    answer: 'Gratis credits bij aanmelding, geen creditcard nodig. Verdien meer via dagelijks inchecken, taken en vrienden uitnodigen voor continu gratis videostijloverdracht.',
                },
                {
                    question: 'Welke andere manieren zijn er om AI-video’s te maken op WeryAI?',
                    answer: 'WeryAI biedt ook Text to Video om video’s te genereren uit tekst en Image to Video om je foto’s te animeren. Alle tools delen dezelfde dagelijkse gratis credits.',
                },
            ],
        },
    },
    id: {
        videoToVideo: {
            title: 'AI Video ke Video Gratis: Transfer Gaya | WeryAI',
            description: 'Transfer gaya video AI gratis — ubah footage menjadi anime, seni 3D, atau cyberpunk dalam detik. Gerakan halus, tanpa kedipan. Vid2Vid dari WeryAI.',
            keywords: 'video ke video AI, AI transfer gaya video, vid2vid, ubah video jadi anime AI, konversi video ke anime, AI restyle video, filter video AI, transfer gaya video gratis online, WeryAI',
            og_title: 'AI Video ke Video Gratis: Transfer Gaya | WeryAI',
            og_description: 'Transfer gaya video AI gratis — ubah footage menjadi anime, seni 3D, atau cyberpunk dalam detik. Gerakan halus, tanpa kedipan. Vid2Vid dari WeryAI.',
            twitter_title: 'AI Video ke Video Gratis: Transfer Gaya | WeryAI',
            twitter_description: 'Transfer gaya video AI gratis — ubah footage menjadi anime, seni 3D, atau cyberpunk dalam detik. Gerakan halus, tanpa kedipan. Vid2Vid dari WeryAI.',
            page: {
                title1: 'Generator AI Video ke Video Gratis (Vid2Vid)',
                title2: 'Unggah video, ketik gaya, dan lihat keajaiban terjadi. Teknologi Video to Video WeryAI menganalisis gerakan di footage sumber dan menerapkan gaya artistik baru berdasarkan prompt teks Anda. Cocok untuk edit anime, efek claymation, atau seni visual surealis.',
                feature_title1: 'Gerakan konsisten',
                feature_desc1: 'Berbeda dari generasi standar, mesin Vid2Vid kami mengunci gerakan pada video sumber agar transisi tetap halus tanpa flicker.',
                feature_title2: 'Dari nyata ke anime',
                feature_desc2: 'Alat #1 untuk kreator. Ubah diri Anda menjadi karakter anime atau avatar 3D gaya Pixar secara instan.',
                feature_title3: 'Kontrol prompt',
                feature_desc3: 'Anda punya kendali kreatif penuh. Cukup ketik "gaya kota cyberpunk" atau "gaya lukisan minyak" untuk menentukan tampilan output.',
                faq: [
                    {
                        question: 'Apa itu AI Video ke Video (Vid2Vid)?',
                        answer: 'Video ke Video adalah proses AI generatif yang mengambil klip video yang ada sebagai input dan "melukis ulang" ke gaya baru sesuai prompt teks Anda, sambil mempertahankan gerakan dan struktur asli.',
                    },
                    {
                        question: 'Bisakah saya mengubah video menjadi gaya anime?',
                        answer: 'Bisa! Ini adalah use case paling populer. Cukup unggah video dan masukkan prompt seperti "gaya anime Jepang, tampilan Studio Ghibli" untuk mengubah footage Anda.',
                    },
                    {
                        question: 'Berapa lama durasi video sumber?',
                        answer: 'Saat ini kami mendukung klip pendek (misalnya 5–10 detik) untuk memastikan kualitas transfer gaya terbaik. Untuk video yang lebih panjang, sebaiknya bagi menjadi beberapa segmen.',
                    },
                    {
                        question: 'Apakah ini berbeda dari editor video?',
                        answer: 'Ya. Editor video tradisional memotong dan memangkas klip. WeryAI Video to Video menghasilkan piksel baru dan sepenuhnya mengubah tekstur serta gaya artistik footage Anda.',
                    },
                    {
                        question: 'Bisakah saya menggunakan Video to Video secara gratis?',
                        answer: 'Pengguna baru mendapatkan kredit gratis saat mendaftar — tanpa perlu kartu kredit. Selain itu, Anda bisa mendapatkan lebih banyak kredit gratis melalui check-in harian, menyelesaikan tugas, dan mengundang teman, sehingga Anda bisa terus menggunakan transfer gaya video secara gratis.',
                    },
                    {
                        question: 'Cara lain apa saja untuk membuat video AI di WeryAI?',
                        answer: 'WeryAI juga menawarkan <a href="/text-to-video">Text to Video</a> untuk membuat video dari teks dan <a href="/image-to-video">Image to Video</a> untuk menganimasi foto Anda. Semua alat berbagi kredit gratis harian yang sama.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Apa itu AI Video ke Video (Vid2Vid)?',
                    answer: 'Video ke Video adalah proses AI generatif yang "melukis ulang" klip video ke gaya baru berdasarkan prompt Anda sambil menjaga gerakan dan struktur.',
                },
                {
                    question: 'Bisakah saya mengubah video menjadi gaya anime?',
                    answer: 'Bisa! Unggah video dan gunakan prompt seperti "gaya anime Jepang, tampilan Studio Ghibli".',
                },
                {
                    question: 'Berapa lama durasi video sumber?',
                    answer: 'Paling cocok untuk klip pendek (misalnya 5–10 detik); video panjang sebaiknya dibagi.',
                },
                {
                    question: 'Apakah ini berbeda dari editor video?',
                    answer: 'Editor tradisional memotong klip, sedangkan Video to Video menghasilkan piksel baru dan mengubah gaya.',
                },
                {
                    question: 'Bisakah saya menggunakan Video to Video secara gratis?',
                    answer: 'Kredit gratis saat mendaftar, tanpa kartu kredit. Dapatkan lebih banyak melalui check-in harian, tugas, dan mengundang teman untuk terus menggunakan transfer gaya video secara gratis.',
                },
                {
                    question: 'Cara lain apa saja untuk membuat video AI di WeryAI?',
                    answer: 'WeryAI juga menawarkan Text to Video untuk membuat video dari teks dan Image to Video untuk menganimasi foto Anda. Semua alat berbagi kredit gratis harian yang sama.',
                },
            ],
        },
    },
    tr: {
        videoToVideo: {
            title: 'Ücretsiz AI Video’dan Video’ya: Stil Transferi | WeryAI',
            description: 'Ücretsiz AI video stil transferi — görüntüleri anime, 3D sanat veya cyberpunk’a saniyeler içinde dönüştürün. Akıcı hareket, titreşim yok. Vid2Vid WeryAI’dan.',
            keywords: 'videodan videoya AI, AI video stil transferi, vid2vid, videoyu animeye çevir AI, video anime dönüştürme, AI video restyle, video filtresi AI, ücretsiz video stil transferi online, WeryAI',
            og_title: 'Ücretsiz AI Video’dan Video’ya: Stil Transferi | WeryAI',
            og_description: 'Ücretsiz AI video stil transferi — görüntüleri anime, 3D sanat veya cyberpunk’a saniyeler içinde dönüştürün. Akıcı hareket, titreşim yok. Vid2Vid WeryAI’dan.',
            twitter_title: 'Ücretsiz AI Video’dan Video’ya: Stil Transferi | WeryAI',
            twitter_description: 'Ücretsiz AI video stil transferi — görüntüleri anime, 3D sanat veya cyberpunk’a saniyeler içinde dönüştürün. Akıcı hareket, titreşim yok. Vid2Vid WeryAI’dan.',
            page: {
                title1: 'Ücretsiz AI Videodan Videoya Üretici (Vid2Vid)',
                title2: 'Bir video yükleyin, bir stil yazın ve sihri izleyin. WeryAI Video to Video teknolojisi, kaynak videodaki hareketi analiz eder ve metin isteminize göre tamamen yeni bir sanatsal stil uygular. Anime düzenlemeleri, claymation efektleri veya sürreal görsel sanat için idealdir.',
                feature_title1: 'Tutarlı hareket',
                feature_desc1: 'Standart üretimin aksine, Vid2Vid motorumuz kaynak videonun hareketini kilitler ve titreşimsiz, akıcı geçişler sağlar.',
                feature_title2: 'Gerçekten animeye',
                feature_desc2: 'İçerik üreticileri için #1 araç. Kendinizi anında bir anime karakterine veya Pixar tarzı 3D avatara dönüştürün.',
                feature_title3: 'İstem kontrolü',
                feature_desc3: 'Tam yaratıcı kontrol sizde. Çıktının görünümünü belirlemek için "siberpunk şehir stili" veya "yağlı boya stili" yazmanız yeterli.',
                faq: [
                    {
                        question: 'AI Videodan Videoya (Vid2Vid) nedir?',
                        answer: 'Video to Video, mevcut bir video klibini girdi olarak alıp metin isteminizle tanımlanan yeni bir stile "yeniden boyayan" ve orijinal hareketi ile yapıyı koruyan üretken bir AI sürecidir.',
                    },
                    {
                        question: 'Videomu anime stiline çevirebilir miyim?',
                        answer: 'Evet! Bu en popüler kullanım. Videonuzu yükleyin ve "Japon anime stili, Studio Ghibli görünümü" gibi istemler girin.',
                    },
                    {
                        question: 'Kaynak video ne kadar uzun olabilir?',
                        answer: 'Şu anda en yüksek kalite için kısa klipleri (ör. 5–10 saniye) destekliyoruz. Daha uzun videoları segmentlere ayırmanızı öneririz.',
                    },
                    {
                        question: 'Bu bir video editöründen farklı mı?',
                        answer: 'Evet. Geleneksel editör klipleri kesip biçer. WeryAI Video to Video yeni pikseller üretir ve görüntünün dokusunu ile sanatsal stilini tamamen değiştirir.',
                    },
                    {
                        question: 'Video to Video ücretsiz olarak kullanılabilir mi?',
                        answer: 'Yeni kullanıcılar kayıt olduklarında ücretsiz kredi alır — kredi kartı gerekmez. Ayrıca günlük giriş, görev tamamlama ve arkadaş davet etme yoluyla daha fazla ücretsiz kredi kazanabilir, video stil transferini ödeme yapmadan sürekli kullanabilirsiniz.',
                    },
                    {
                        question: 'WeryAI’da AI video oluşturmanın başka yolları var mı?',
                        answer: 'WeryAI ayrıca yazılı istemlerden video üretmek için <a href="/text-to-video">Text to Video</a> ve fotoğraflarınızı canlandırmak için <a href="/image-to-video">Image to Video</a> sunar. Tüm araçlar aynı ücretsiz günlük kredileri paylaşır.',
                    },
                ],
            },
            faq: [
                {
                    question: 'AI Videodan Videoya (Vid2Vid) nedir?',
                    answer: 'Video to Video, mevcut bir klibi yeni bir stile yeniden boyayan üretken bir AI sürecidir; hareket ve yapı korunur.',
                },
                {
                    question: 'Videomu anime stiline çevirebilir miyim?',
                    answer: 'Evet! Videonuzu yükleyin ve "Japon anime stili, Studio Ghibli görünümü" gibi istemler kullanın.',
                },
                {
                    question: 'Kaynak video ne kadar uzun olabilir?',
                    answer: 'En iyi kalite için kısa klipler (ör. 5–10 saniye) önerilir; daha uzun videoları bölün.',
                },
                {
                    question: 'Bu bir video editöründen farklı mı?',
                    answer: 'Editörler kesip biçer; Video to Video yeni pikseller üretir ve stili değiştirir.',
                },
                {
                    question: 'Video to Video ücretsiz olarak kullanılabilir mi?',
                    answer: 'Kayıt olduğunuzda ücretsiz kredi alırsınız, kredi kartı gerekmez. Günlük giriş, görevler ve arkadaş daveti ile daha fazla ücretsiz kredi kazanarak video stil transferini ücretsiz kullanmaya devam edebilirsiniz.',
                },
                {
                    question: 'WeryAI’da AI video oluşturmanın başka yolları var mı?',
                    answer: 'WeryAI ayrıca yazılı istemlerden video üretmek için Text to Video ve fotoğraflarınızı canlandırmak için Image to Video sunar. Tüm araçlar aynı ücretsiz günlük kredileri paylaşır.',
                },
            ],
        },
    },
}
